var items = {
  "block.minecraft.acacia_button": "Bouton kasia",
  "block.minecraft.acacia_door": "Dor gasia",
  "block.minecraft.acacia_fence": "Kloued kasia",
  "block.minecraft.acacia_fence_gate": "Dorikell gasia",
  "block.minecraft.acacia_hanging_sign": "Panell gasia a-ispilh",
  "block.minecraft.acacia_leaves": "Delioù kasia",
  "block.minecraft.acacia_log": "Etev kasia",
  "block.minecraft.acacia_planks": "Plankennoù kasia",
  "block.minecraft.acacia_pressure_plate": "Plakenn wask kasia",
  "block.minecraft.acacia_sapling": "Strujenn gasia",
  "block.minecraft.acacia_shelf": "Stalenn gasia",
  "block.minecraft.acacia_sign": "Panell gasia",
  "block.minecraft.acacia_slab": "Dar gasia",
  "block.minecraft.acacia_stairs": "Diri kasia",
  "block.minecraft.acacia_trapdoor": "Trap kasia",
  "block.minecraft.acacia_wall_hanging_sign": "Panell-voger gasia a-ispilh",
  "block.minecraft.acacia_wall_sign": "Panell-voger kasia",
  "block.minecraft.acacia_wood": "Koad kasia",
  "block.minecraft.activator_rail": "Hent-houarn gweredekaer",
  "block.minecraft.air": "Aer",
  "block.minecraft.allium": "Allium",
  "block.minecraft.amethyst_block": "Bloc'h ametist",
  "block.minecraft.amethyst_cluster": "Bern ametist",
  "block.minecraft.ancient_debris": "Dismantroù kozh",
  "block.minecraft.andesite": "Andezit",
  "block.minecraft.andesite_slab": "Dar andezit",
  "block.minecraft.andesite_stairs": "Diri andezit",
  "block.minecraft.andesite_wall": "Moger andezit",
  "block.minecraft.anvil": "Annev",
  "block.minecraft.attached_melon_stem": "Garenn sukrinenn staget",
  "block.minecraft.attached_pumpkin_stem": "Garenn sitrouilhezenn staget",
  "block.minecraft.azalea": "Brug-roz",
  "block.minecraft.azalea_leaves": "Delioù brug-roz",
  "block.minecraft.azure_bluet": "Houstonia",
  "block.minecraft.bamboo": "Bambou",
  "block.minecraft.bamboo_block": "Bloc'h bambouz",
  "block.minecraft.bamboo_button": "Bouton bambouz",
  "block.minecraft.bamboo_door": "Dor vambouz",
  "block.minecraft.bamboo_fence": "Kloued vambouz",
  "block.minecraft.bamboo_fence_gate": "Dorikell vambouz",
  "block.minecraft.bamboo_hanging_sign": "Panell vambouz a-ispilh",
  "block.minecraft.bamboo_mosaic": "Marelladur bambouz",
  "block.minecraft.bamboo_mosaic_slab": "Dar varelladur bambouz",
  "block.minecraft.bamboo_mosaic_stairs": "Diri marelladur bambouz",
  "block.minecraft.bamboo_planks": "Plankennoù bambouz",
  "block.minecraft.bamboo_pressure_plate": "Plakenn wask vambouz",
  "block.minecraft.bamboo_sapling": "Strujenn vambouz",
  "block.minecraft.bamboo_shelf": "Stalenn vambouz",
  "block.minecraft.bamboo_sign": "Panell vambouz",
  "block.minecraft.bamboo_slab": "Dar vambouz",
  "block.minecraft.bamboo_stairs": "Diri bambouz",
  "block.minecraft.bamboo_trapdoor": "Trap bambouz",
  "block.minecraft.bamboo_wall_hanging_sign": "Panell-voger vambouz a-ispilh",
  "block.minecraft.bamboo_wall_sign": "Panell-voger vambouz",
  "block.minecraft.banner.base.black": "Plaen en sabel",
  "block.minecraft.banner.base.blue": "Plaen glazur",
  "block.minecraft.banner.base.brown": "Plaen en tanneg",
  "block.minecraft.banner.base.cyan": "Plaen en sian",
  "block.minecraft.banner.base.gray": "Plaen en houarn",
  "block.minecraft.banner.base.green": "Plaen geoted",
  "block.minecraft.banner.base.light_blue": "Plaen glazur sklaer",
  "block.minecraft.banner.base.light_gray": "Plaen en arc'hant gris",
  "block.minecraft.banner.base.lime": "Plaen geoted sklaer",
  "block.minecraft.banner.base.magenta": "Plaen limestra",
  "block.minecraft.banner.base.orange": "Plaen aouraval",
  "block.minecraft.banner.base.pink": "Plaen en-gwirion",
  "block.minecraft.banner.base.purple": "Plaen mouk",
  "block.minecraft.banner.base.red": "Plaen en gul",
  "block.minecraft.banner.base.white": "Plaen en arc'hant",
  "block.minecraft.banner.base.yellow": "Plaen aour",
  "block.minecraft.banner.border.black": "Bevenn en sabel",
  "block.minecraft.banner.border.blue": "Bevenn en glazur",
  "block.minecraft.banner.border.brown": "Bevenn en tanneg",
  "block.minecraft.banner.border.cyan": "Bevenn en sian",
  "block.minecraft.banner.border.gray": "Bevenn en houarn",
  "block.minecraft.banner.border.green": "Bevenn geotet",
  "block.minecraft.banner.border.light_blue": "Bevenn en glazur sklaer",
  "block.minecraft.banner.border.light_gray": "Bevenn en arc'hant gris",
  "block.minecraft.banner.border.lime": "Bevenn geotet sklaer",
  "block.minecraft.banner.border.magenta": "Bevenn en mouareg",
  "block.minecraft.banner.border.orange": "Bevenn en orañjezeg",
  "block.minecraft.banner.border.pink": "Bevenn en-gwirion",
  "block.minecraft.banner.border.purple": "Bevenn en mouk",
  "block.minecraft.banner.border.red": "Bevenn en gul",
  "block.minecraft.banner.border.white": "Bevenn en arc'hant",
  "block.minecraft.banner.border.yellow": "Bevenn en aour",
  "block.minecraft.banner.bricks.black": "Maez mogeriet en sabel",
  "block.minecraft.banner.bricks.blue": "Maez mogeriet en glazur",
  "block.minecraft.banner.bricks.brown": "Maez mogeriet en tanneg",
  "block.minecraft.banner.bricks.cyan": "Maez mogeriet en sian",
  "block.minecraft.banner.bricks.gray": "Maez mogeriet en houarn",
  "block.minecraft.banner.bricks.green": "Maez mogeriet geotet",
  "block.minecraft.banner.bricks.light_blue": "Maez mogeriet en glazur sklaer",
  "block.minecraft.banner.bricks.light_gray": "Maez mogeriet en arc'hant gris",
  "block.minecraft.banner.bricks.lime": "Maez mogeriet geotet sklaer",
  "block.minecraft.banner.bricks.magenta": "Maez mogeriet en mouareg",
  "block.minecraft.banner.bricks.orange": "Maez mogeriet en orañjezeg",
  "block.minecraft.banner.bricks.pink": "Maez mogeriet en-gwirion",
  "block.minecraft.banner.bricks.purple": "Maez mogeriet en mouk",
  "block.minecraft.banner.bricks.red": "Maez mogeriet en gul",
  "block.minecraft.banner.bricks.white": "Maez mogeriet en arc'hant",
  "block.minecraft.banner.bricks.yellow": "Maez mogeriet en aour",
  "block.minecraft.banner.circle.black": "Torzhell en sabel",
  "block.minecraft.banner.circle.blue": "Torzhell en glazur",
  "block.minecraft.banner.circle.brown": "Torzhell en tanneg",
  "block.minecraft.banner.circle.cyan": "Torzhell en sian",
  "block.minecraft.banner.circle.gray": "Torzhell en houarn",
  "block.minecraft.banner.circle.green": "Torzhell geotet",
  "block.minecraft.banner.circle.light_blue": "Torzhell en glazur sklaer",
  "block.minecraft.banner.circle.light_gray": "Torzhell en arc'hant gris",
  "block.minecraft.banner.circle.lime": "Torzhell geotet sklaer",
  "block.minecraft.banner.circle.magenta": "Torzhell en mouareg",
  "block.minecraft.banner.circle.orange": "Torzhell en orañjezeg",
  "block.minecraft.banner.circle.pink": "Torzhell en-gwirion",
  "block.minecraft.banner.circle.purple": "Torzhell en mouk",
  "block.minecraft.banner.circle.red": "Torzhell en gul",
  "block.minecraft.banner.circle.white": "Torzhell en arc'hant",
  "block.minecraft.banner.circle.yellow": "Torzhell en aour",
  "block.minecraft.banner.creeper.black": "Penn Creeper en sabel",
  "block.minecraft.banner.creeper.blue": "Penn Creeper en glazur",
  "block.minecraft.banner.creeper.brown": "Penn Creeper en tanneg",
  "block.minecraft.banner.creeper.cyan": "Penn Creeper en sian",
  "block.minecraft.banner.creeper.gray": "Penn Creeper en houarn",
  "block.minecraft.banner.creeper.green": "Penn Creeper geotet",
  "block.minecraft.banner.creeper.light_blue": "Penn Creeper en glazur sklaer",
  "block.minecraft.banner.creeper.light_gray": "Penn Creeper en arc'hant gris",
  "block.minecraft.banner.creeper.lime": "Penn Creeper geotet sklaer",
  "block.minecraft.banner.creeper.magenta": "Penn Creeper en mouareg",
  "block.minecraft.banner.creeper.orange": "Penn Creeper en orañjezeg",
  "block.minecraft.banner.creeper.pink": "Penn Creeper en-gwirion",
  "block.minecraft.banner.creeper.purple": "Penn Creeper en mouk",
  "block.minecraft.banner.creeper.red": "Penn Creeper en gul",
  "block.minecraft.banner.creeper.white": "Penn Creeper en arc'hant",
  "block.minecraft.banner.creeper.yellow": "Penn Creeper en aour",
  "block.minecraft.banner.cross.black": "Lammell en sabel",
  "block.minecraft.banner.cross.blue": "Lammell en glazur",
  "block.minecraft.banner.cross.brown": "Lammell en tanneg",
  "block.minecraft.banner.cross.cyan": "Lammell en sian",
  "block.minecraft.banner.cross.gray": "Lammell en houarn",
  "block.minecraft.banner.cross.green": "Lammell geotet",
  "block.minecraft.banner.cross.light_blue": "Lammell en glazur sklaer",
  "block.minecraft.banner.cross.light_gray": "Lammell en arc'hant gris",
  "block.minecraft.banner.cross.lime": "Lammell geotet sklaer",
  "block.minecraft.banner.cross.magenta": "Lammell en mouareg",
  "block.minecraft.banner.cross.orange": "Lammell en orañjezeg",
  "block.minecraft.banner.cross.pink": "Lammell en-gwirion",
  "block.minecraft.banner.cross.purple": "Lammell en mouk",
  "block.minecraft.banner.cross.red": "Lammell en gul",
  "block.minecraft.banner.cross.white": "Lammell en arc'hant",
  "block.minecraft.banner.cross.yellow": "Lammell en aour",
  "block.minecraft.banner.curly_border.black": "Bevenn korzennek en sabel",
  "block.minecraft.banner.curly_border.blue": "Bevenn korzennek en glazur",
  "block.minecraft.banner.curly_border.brown": "Bevenn korzennek en tanneg",
  "block.minecraft.banner.curly_border.cyan": "Bevenn korzennek en sian",
  "block.minecraft.banner.curly_border.gray": "Bevenn korzennek en houarn",
  "block.minecraft.banner.curly_border.green": "Bevenn korzennek geotet",
  "block.minecraft.banner.curly_border.light_blue": "Bevenn korzennek en glazur sklaer",
  "block.minecraft.banner.curly_border.light_gray": "Bevenn korzennek en arc'hant gris",
  "block.minecraft.banner.curly_border.lime": "Bevenn korzennek geotet sklaer",
  "block.minecraft.banner.curly_border.magenta": "Bevenn korzennek en mouareg",
  "block.minecraft.banner.curly_border.orange": "Bevenn korzennek en orañjezeg",
  "block.minecraft.banner.curly_border.pink": "Bevenn korzennek en-gwirion",
  "block.minecraft.banner.curly_border.purple": "Bevenn korzennek en mouk",
  "block.minecraft.banner.curly_border.red": "Bevenn korzennek en gul",
  "block.minecraft.banner.curly_border.white": "Bevenn korzennek en arc'hant",
  "block.minecraft.banner.curly_border.yellow": "Bevenn korzennek en aour",
  "block.minecraft.banner.diagonal_left.black": "Skejet, en sabel e kentañ",
  "block.minecraft.banner.diagonal_left.blue": "Skejet, en glazur e kentañ",
  "block.minecraft.banner.diagonal_left.brown": "Skejet, en tanneg e kentañ",
  "block.minecraft.banner.diagonal_left.cyan": "Skejet, en sian e kentañ",
  "block.minecraft.banner.diagonal_left.gray": "Skejet, en houarn e kentañ",
  "block.minecraft.banner.diagonal_left.green": "Skejet, geotet e kentañ",
  "block.minecraft.banner.diagonal_left.light_blue": "Skejet, en glazur sklaer e kentañ",
  "block.minecraft.banner.diagonal_left.light_gray": "Skejet, en arc'hant gris e kentañ",
  "block.minecraft.banner.diagonal_left.lime": "Skejet, geotet sklaer e kentañ",
  "block.minecraft.banner.diagonal_left.magenta": "Skejet, en mouareg e kentañ",
  "block.minecraft.banner.diagonal_left.orange": "Skejet, en orañjezeg e kentañ",
  "block.minecraft.banner.diagonal_left.pink": "Skejet, en-gwirion e kentañ",
  "block.minecraft.banner.diagonal_left.purple": "Skejet, en mouk e kentañ",
  "block.minecraft.banner.diagonal_left.red": "Skejet, en gul e kentañ",
  "block.minecraft.banner.diagonal_left.white": "Skejet, en arc'hant e kentañ",
  "block.minecraft.banner.diagonal_left.yellow": "Skejet, en aour e kentañ",
  "block.minecraft.banner.diagonal_right.black": "Benet, en sabel e kentañ",
  "block.minecraft.banner.diagonal_right.blue": "Benet, en glazur e kentañ",
  "block.minecraft.banner.diagonal_right.brown": "Benet, en tanneg e kentañ",
  "block.minecraft.banner.diagonal_right.cyan": "Benet, en sian e kentañ",
  "block.minecraft.banner.diagonal_right.gray": "Benet, en houarn e kentañ",
  "block.minecraft.banner.diagonal_right.green": "Benet, geotet e kentañ",
  "block.minecraft.banner.diagonal_right.light_blue": "Benet, en glazur sklaer e kentañ",
  "block.minecraft.banner.diagonal_right.light_gray": "Benet, en arc'hant gris e kentañ",
  "block.minecraft.banner.diagonal_right.lime": "Benet, geotet sklaer e kentañ",
  "block.minecraft.banner.diagonal_right.magenta": "Benet, en mouareg e kentañ",
  "block.minecraft.banner.diagonal_right.orange": "Benet, en orañjezeg e kentañ",
  "block.minecraft.banner.diagonal_right.pink": "Benet, en-gwirion e kentañ",
  "block.minecraft.banner.diagonal_right.purple": "Benet, en mouk e kentañ",
  "block.minecraft.banner.diagonal_right.red": "Benet, en gul e kentañ",
  "block.minecraft.banner.diagonal_right.white": "Benet, en arc'hant e kentañ",
  "block.minecraft.banner.diagonal_right.yellow": "Benet, en aour e kentañ",
  "block.minecraft.banner.diagonal_up_left.black": "Benet, en sabel da eil",
  "block.minecraft.banner.diagonal_up_left.blue": "Benet, en glazur da eil",
  "block.minecraft.banner.diagonal_up_left.brown": "Benet, en tanneg da eil",
  "block.minecraft.banner.diagonal_up_left.cyan": "Benet, en sian da eil",
  "block.minecraft.banner.diagonal_up_left.gray": "Benet, en houarn da eil",
  "block.minecraft.banner.diagonal_up_left.green": "Benet, geotet da eil",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Benet, en glazur sklaer da eil",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Benet, en arc'hant gris da eil",
  "block.minecraft.banner.diagonal_up_left.lime": "Benet, geotet sklaer da eil",
  "block.minecraft.banner.diagonal_up_left.magenta": "Benet, en mouareg da eil",
  "block.minecraft.banner.diagonal_up_left.orange": "Benet, en orañjezeg da eil",
  "block.minecraft.banner.diagonal_up_left.pink": "Benet, en-gwirion da eil",
  "block.minecraft.banner.diagonal_up_left.purple": "Benet, en mouk da eil",
  "block.minecraft.banner.diagonal_up_left.red": "Benet, en gul da eil",
  "block.minecraft.banner.diagonal_up_left.white": "Benet, en arc'hant da eil",
  "block.minecraft.banner.diagonal_up_left.yellow": "Benet, en aour da eil",
  "block.minecraft.banner.diagonal_up_right.black": "Skejet, en sabel da eil",
  "block.minecraft.banner.diagonal_up_right.blue": "Skejet, en glazur da eil",
  "block.minecraft.banner.diagonal_up_right.brown": "Skejet, en tanneg da eil",
  "block.minecraft.banner.diagonal_up_right.cyan": "Skejet, en sian da eil",
  "block.minecraft.banner.diagonal_up_right.gray": "Skejet, en houarn da eil",
  "block.minecraft.banner.diagonal_up_right.green": "Skejet, geotet da eil",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Skejet, en glazur sklaer da eil",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Skejet, en arc'hant gris da eil",
  "block.minecraft.banner.diagonal_up_right.lime": "Skejet, geotet sklaer da eil",
  "block.minecraft.banner.diagonal_up_right.magenta": "Skejet, en mouareg da eil",
  "block.minecraft.banner.diagonal_up_right.orange": "Skejet, en orañjezeg da eil",
  "block.minecraft.banner.diagonal_up_right.pink": "Skejet, en-gwirion da eil",
  "block.minecraft.banner.diagonal_up_right.purple": "Skejet, en mouk da eil",
  "block.minecraft.banner.diagonal_up_right.red": "Skejet, en gul da eil",
  "block.minecraft.banner.diagonal_up_right.white": "Skejet, en arc'hant da eil",
  "block.minecraft.banner.diagonal_up_right.yellow": "Skejet, en aour da eil",
  "block.minecraft.banner.flow.black": "Korventenn en sabel",
  "block.minecraft.banner.flow.blue": "Korventenn en glazur",
  "block.minecraft.banner.flow.brown": "Korventenn en tanneg",
  "block.minecraft.banner.flow.cyan": "Korventenn en sian",
  "block.minecraft.banner.flow.gray": "Korventenn en houarn",
  "block.minecraft.banner.flow.green": "Korventenn geotet",
  "block.minecraft.banner.flow.light_blue": "Korventenn en glazur sklaer",
  "block.minecraft.banner.flow.light_gray": "Korventenn en arc'hant gris",
  "block.minecraft.banner.flow.lime": "Korventenn geotet sklaer",
  "block.minecraft.banner.flow.magenta": "Korventenn en mouareg",
  "block.minecraft.banner.flow.orange": "Korventenn en orañjezeg",
  "block.minecraft.banner.flow.pink": "Korventenn en-gwirion",
  "block.minecraft.banner.flow.purple": "Korventenn en mouk",
  "block.minecraft.banner.flow.red": "Korventenn en gul",
  "block.minecraft.banner.flow.white": "Korventenn en arc'hant",
  "block.minecraft.banner.flow.yellow": "Korventenn en aour",
  "block.minecraft.banner.flower.black": "Bleunienn en sabel",
  "block.minecraft.banner.flower.blue": "Bleunienn en glazur",
  "block.minecraft.banner.flower.brown": "Bleunienn en tanneg",
  "block.minecraft.banner.flower.cyan": "Bleunienn en sian",
  "block.minecraft.banner.flower.gray": "Bleunienn en houarn",
  "block.minecraft.banner.flower.green": "Bleunienn geotet",
  "block.minecraft.banner.flower.light_blue": "Bleunienn en glazur sklaer",
  "block.minecraft.banner.flower.light_gray": "Bleunienn en arc'hant gris",
  "block.minecraft.banner.flower.lime": "Bleunienn geotet sklaer",
  "block.minecraft.banner.flower.magenta": "Bleunienn en mouareg",
  "block.minecraft.banner.flower.orange": "Bleunienn en orañjezeg",
  "block.minecraft.banner.flower.pink": "Bleunienn en-gwirion",
  "block.minecraft.banner.flower.purple": "Bleunienn en mouk",
  "block.minecraft.banner.flower.red": "Bleunienn en gul",
  "block.minecraft.banner.flower.white": "Bleunienn en arc'hant",
  "block.minecraft.banner.flower.yellow": "Bleunienn en aour",
  "block.minecraft.banner.globe.black": "Boul en sabel",
  "block.minecraft.banner.globe.blue": "Boul en glazur",
  "block.minecraft.banner.globe.brown": "Boul en tanneg",
  "block.minecraft.banner.globe.cyan": "Boul en sian",
  "block.minecraft.banner.globe.gray": "Boul en houarn",
  "block.minecraft.banner.globe.green": "Boul geotet",
  "block.minecraft.banner.globe.light_blue": "Boul en glazur sklaer",
  "block.minecraft.banner.globe.light_gray": "Boul en arc'hant gris",
  "block.minecraft.banner.globe.lime": "Boul geotet sklaer",
  "block.minecraft.banner.globe.magenta": "Boul en mouareg",
  "block.minecraft.banner.globe.orange": "Boul en orañjezeg",
  "block.minecraft.banner.globe.pink": "Boul en-gwirion",
  "block.minecraft.banner.globe.purple": "Boul en mouk",
  "block.minecraft.banner.globe.red": "Boul en gul",
  "block.minecraft.banner.globe.white": "Boul en arc'hant",
  "block.minecraft.banner.globe.yellow": "Boul en aour",
  "block.minecraft.banner.gradient.black": "Ilrezenn en sabel",
  "block.minecraft.banner.gradient.blue": "Ilrezenn en glazur",
  "block.minecraft.banner.gradient.brown": "Ilrezenn en tanneg",
  "block.minecraft.banner.gradient.cyan": "Ilrezenn en sian",
  "block.minecraft.banner.gradient.gray": "Ilrezenn en houarn",
  "block.minecraft.banner.gradient.green": "Ilrezenn geotet",
  "block.minecraft.banner.gradient.light_blue": "Ilrezenn en glazur sklaer",
  "block.minecraft.banner.gradient.light_gray": "Ilrezenn en arc'hant gris",
  "block.minecraft.banner.gradient.lime": "Ilrezenn geotet sklaer",
  "block.minecraft.banner.gradient.magenta": "Ilrezenn en mouareg",
  "block.minecraft.banner.gradient.orange": "Ilrezenn en orañjezeg",
  "block.minecraft.banner.gradient.pink": "Ilrezenn en-gwirion",
  "block.minecraft.banner.gradient.purple": "Ilrezenn en mouk",
  "block.minecraft.banner.gradient.red": "Ilrezenn en gul",
  "block.minecraft.banner.gradient.white": "Ilrezenn en arc'hant",
  "block.minecraft.banner.gradient.yellow": "Ilrezenn en aour",
  "block.minecraft.banner.gradient_up.black": "Ilrezenn en sabel ouzh beg",
  "block.minecraft.banner.gradient_up.blue": "Ilrezenn en glazur ouzh beg",
  "block.minecraft.banner.gradient_up.brown": "Ilrezenn en tanneg ouzh beg",
  "block.minecraft.banner.gradient_up.cyan": "Ilrezenn en sian ouzh beg",
  "block.minecraft.banner.gradient_up.gray": "Ilrezenn en houarn ouzh beg",
  "block.minecraft.banner.gradient_up.green": "Ilrezenn geotet ouzh beg",
  "block.minecraft.banner.gradient_up.light_blue": "Ilrezenn en glazur sklaer ouzh beg",
  "block.minecraft.banner.gradient_up.light_gray": "Ilrezenn en arc'hant gris ouzh beg",
  "block.minecraft.banner.gradient_up.lime": "Ilrezenn geotet sklaer ouzh beg",
  "block.minecraft.banner.gradient_up.magenta": "Ilrezenn en mouareg ouzh beg",
  "block.minecraft.banner.gradient_up.orange": "Ilrezenn en orañjezeg ouzh beg",
  "block.minecraft.banner.gradient_up.pink": "Ilrezenn en-gwirion ouzh beg",
  "block.minecraft.banner.gradient_up.purple": "Ilrezenn en mouk ouzh beg",
  "block.minecraft.banner.gradient_up.red": "Ilrezenn en gul ouzh beg",
  "block.minecraft.banner.gradient_up.white": "Ilrezenn en arc'hant ouzh beg",
  "block.minecraft.banner.gradient_up.yellow": "Ilrezenn en aour ouzh beg",
  "block.minecraft.banner.guster.black": "Gwent en sabel",
  "block.minecraft.banner.guster.blue": "Gwent en glazur",
  "block.minecraft.banner.guster.brown": "Gwent en tanneg",
  "block.minecraft.banner.guster.cyan": "Gwent en sian",
  "block.minecraft.banner.guster.gray": "Gwent en houarn",
  "block.minecraft.banner.guster.green": "Gwent geotet",
  "block.minecraft.banner.guster.light_blue": "Gwent en glazur sklaer",
  "block.minecraft.banner.guster.light_gray": "Gwent en arc'hant gris",
  "block.minecraft.banner.guster.lime": "Gwent geotet sklaer",
  "block.minecraft.banner.guster.magenta": "Gwent en mouareg",
  "block.minecraft.banner.guster.orange": "Gwent en orañjezeg",
  "block.minecraft.banner.guster.pink": "Gwent en-gwirion",
  "block.minecraft.banner.guster.purple": "Gwent en mouk",
  "block.minecraft.banner.guster.red": "Gwent en gul",
  "block.minecraft.banner.guster.white": "Gwent en arc'hant",
  "block.minecraft.banner.guster.yellow": "Gwent en aour",
  "block.minecraft.banner.half_horizontal.black": "Troc'het, en sabel da gentañ",
  "block.minecraft.banner.half_horizontal.blue": "Troc'het, en glazur da gentañ",
  "block.minecraft.banner.half_horizontal.brown": "Troc'het, en tanneg da gentañ",
  "block.minecraft.banner.half_horizontal.cyan": "Troc'het, en sian da gentañ",
  "block.minecraft.banner.half_horizontal.gray": "Troc'het, en houarn da gentañ",
  "block.minecraft.banner.half_horizontal.green": "Troc'het, geotet da gentañ",
  "block.minecraft.banner.half_horizontal.light_blue": "Troc'het, en glazur sklaer da gentañ",
  "block.minecraft.banner.half_horizontal.light_gray": "Troc'het, en arc'hant gris da gentañ",
  "block.minecraft.banner.half_horizontal.lime": "Troc'het, geotet sklaer da gentañ",
  "block.minecraft.banner.half_horizontal.magenta": "Troc'het, en mouareg da gentañ",
  "block.minecraft.banner.half_horizontal.orange": "Troc'het, en orañjezeg da gentañ",
  "block.minecraft.banner.half_horizontal.pink": "Troc'het, en-gwirion da gentañ",
  "block.minecraft.banner.half_horizontal.purple": "Troc'het, en mouk da gentañ",
  "block.minecraft.banner.half_horizontal.red": "Troc'het, en gul da gentañ",
  "block.minecraft.banner.half_horizontal.white": "Troc'het, en arc'hant da gentañ",
  "block.minecraft.banner.half_horizontal.yellow": "Troc'het, en aour da gentañ",
  "block.minecraft.banner.half_horizontal_bottom.black": "Troc'het, en sabel da eil",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Troc'het, en glazur da eil",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Troc'het, en tanneg da eil",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Troc'het, en sian da eil",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Troc'het, en houarn da eil",
  "block.minecraft.banner.half_horizontal_bottom.green": "Troc'het, geotet da eil",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Troc'het, en glazur sklaer da eil",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Troc'het, en arc'hant gris da eil",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Troc'het, geotet sklaer da eil",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Troc'het, en mouareg da eil",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Troc'het, en orañjezeg da eil",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Troc'het, en-gwirion da eil",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Troc'het, en mouk da eil",
  "block.minecraft.banner.half_horizontal_bottom.red": "Troc'het, en gul da eil",
  "block.minecraft.banner.half_horizontal_bottom.white": "Troc'het, en arc'hant da eil",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Troc'het, en aour da eil",
  "block.minecraft.banner.half_vertical.black": "Rannet, en sabel da gentañ",
  "block.minecraft.banner.half_vertical.blue": "Rannet, en glazur da gentañ",
  "block.minecraft.banner.half_vertical.brown": "Rannet, en tanneg da gentañ",
  "block.minecraft.banner.half_vertical.cyan": "Rannet, en sian da gentañ",
  "block.minecraft.banner.half_vertical.gray": "Rannet, en houarn da gentañ",
  "block.minecraft.banner.half_vertical.green": "Rannet, geotet da gentañ",
  "block.minecraft.banner.half_vertical.light_blue": "Rannet, en glazur sklaer da gentañ",
  "block.minecraft.banner.half_vertical.light_gray": "Rannet, en arc'hant gris da gentañ",
  "block.minecraft.banner.half_vertical.lime": "Rannet, geotet sklaer da gentañ",
  "block.minecraft.banner.half_vertical.magenta": "Rannet, en mouareg da gentañ",
  "block.minecraft.banner.half_vertical.orange": "Rannet, en orañjezeg da gentañ",
  "block.minecraft.banner.half_vertical.pink": "Rannet, en-gwirion da gentañ",
  "block.minecraft.banner.half_vertical.purple": "Rannet, en mouk da gentañ",
  "block.minecraft.banner.half_vertical.red": "Rannet, en gul da gentañ",
  "block.minecraft.banner.half_vertical.white": "Rannet, en arc'hant da gentañ",
  "block.minecraft.banner.half_vertical.yellow": "Rannet, en aour da gentañ",
  "block.minecraft.banner.half_vertical_right.black": "Rannet, en sabel da eil",
  "block.minecraft.banner.half_vertical_right.blue": "Rannet, en glazur da eil",
  "block.minecraft.banner.half_vertical_right.brown": "Rannet, en tanneg da eil",
  "block.minecraft.banner.half_vertical_right.cyan": "Rannet, en sian da eil",
  "block.minecraft.banner.half_vertical_right.gray": "Rannet, en houarn da eil",
  "block.minecraft.banner.half_vertical_right.green": "Rannet, geotet da eil",
  "block.minecraft.banner.half_vertical_right.light_blue": "Rannet, en glazur sklaer da eil",
  "block.minecraft.banner.half_vertical_right.light_gray": "Rannet, en arc'hant gris da eil",
  "block.minecraft.banner.half_vertical_right.lime": "Rannet, geotet sklaer da eil",
  "block.minecraft.banner.half_vertical_right.magenta": "Rannet, en mouareg da eil",
  "block.minecraft.banner.half_vertical_right.orange": "Rannet, en orañjezeg da eil",
  "block.minecraft.banner.half_vertical_right.pink": "Rannet, en-gwirion da eil",
  "block.minecraft.banner.half_vertical_right.purple": "Rannet, en mouk da eil",
  "block.minecraft.banner.half_vertical_right.red": "Rannet, en gul da eil",
  "block.minecraft.banner.half_vertical_right.white": "Rannet, en arc'hant da eil",
  "block.minecraft.banner.half_vertical_right.yellow": "Rannet, en aour da eil",
  "block.minecraft.banner.mojang.black": "Arouez en sabel",
  "block.minecraft.banner.mojang.blue": "Arouez en glazur",
  "block.minecraft.banner.mojang.brown": "Arouez en tanneg",
  "block.minecraft.banner.mojang.cyan": "Arouez en sian",
  "block.minecraft.banner.mojang.gray": "Arouez en houarn",
  "block.minecraft.banner.mojang.green": "Arouez geotet",
  "block.minecraft.banner.mojang.light_blue": "Arouez en glazur sklaer",
  "block.minecraft.banner.mojang.light_gray": "Arouez en arc'hant gris",
  "block.minecraft.banner.mojang.lime": "Arouez geotet sklaer",
  "block.minecraft.banner.mojang.magenta": "Arouez en mouareg",
  "block.minecraft.banner.mojang.orange": "Arouez en orañjezeg",
  "block.minecraft.banner.mojang.pink": "Arouez en-gwirion",
  "block.minecraft.banner.mojang.purple": "Arouez en mouk",
  "block.minecraft.banner.mojang.red": "Arouez en gul",
  "block.minecraft.banner.mojang.white": "Arouez en arc'hant",
  "block.minecraft.banner.mojang.yellow": "Arouez en aour",
  "block.minecraft.banner.piglin.black": "Mojell en sabel",
  "block.minecraft.banner.piglin.blue": "Mojell en glazur",
  "block.minecraft.banner.piglin.brown": "Mojell en tanneg",
  "block.minecraft.banner.piglin.cyan": "Mojell sian",
  "block.minecraft.banner.piglin.gray": "Mojell en houarn",
  "block.minecraft.banner.piglin.green": "Mojell c'heotet",
  "block.minecraft.banner.piglin.light_blue": "Mojell en glazur sklaer",
  "block.minecraft.banner.piglin.light_gray": "Mojell en arc'hant gris",
  "block.minecraft.banner.piglin.lime": "Mojell c'heotet sklaer",
  "block.minecraft.banner.piglin.magenta": "Mojell en mouareg",
  "block.minecraft.banner.piglin.orange": "Mojell en orañjezeg",
  "block.minecraft.banner.piglin.pink": "Mojell en-gwirion",
  "block.minecraft.banner.piglin.purple": "Mojell en mouk",
  "block.minecraft.banner.piglin.red": "Mojell en gul",
  "block.minecraft.banner.piglin.white": "Mojell en arc'hant",
  "block.minecraft.banner.piglin.yellow": "Mojell en aour",
  "block.minecraft.banner.rhombus.black": "Talbennan en sabel",
  "block.minecraft.banner.rhombus.blue": "Talbennan en glazur",
  "block.minecraft.banner.rhombus.brown": "Talbennan en tanneg",
  "block.minecraft.banner.rhombus.cyan": "Talbennan en sian",
  "block.minecraft.banner.rhombus.gray": "Talbennan en houarn",
  "block.minecraft.banner.rhombus.green": "Talbennan geotet",
  "block.minecraft.banner.rhombus.light_blue": "Talbennan en glazur sklaer",
  "block.minecraft.banner.rhombus.light_gray": "Talbennan en arc'hant gris",
  "block.minecraft.banner.rhombus.lime": "Talbennan geotet sklaer",
  "block.minecraft.banner.rhombus.magenta": "Talbennan en mouareg",
  "block.minecraft.banner.rhombus.orange": "Talbennan en orañjezeg",
  "block.minecraft.banner.rhombus.pink": "Talbennan en-gwirion",
  "block.minecraft.banner.rhombus.purple": "Talbennan en mouk",
  "block.minecraft.banner.rhombus.red": "Talbennan en gul",
  "block.minecraft.banner.rhombus.white": "Talbennan en arc'hant",
  "block.minecraft.banner.rhombus.yellow": "Talbennan en orañjezeg",
  "block.minecraft.banner.skull.black": "Klopenn en sabel",
  "block.minecraft.banner.skull.blue": "Klopenn en glazur",
  "block.minecraft.banner.skull.brown": "Klopenn en tanneg",
  "block.minecraft.banner.skull.cyan": "Klopenn en sian",
  "block.minecraft.banner.skull.gray": "Klopenn en houarn",
  "block.minecraft.banner.skull.green": "Klopenn geotet",
  "block.minecraft.banner.skull.light_blue": "Klopenn en glazur sklaer",
  "block.minecraft.banner.skull.light_gray": "Klopenn en arc'hant gris",
  "block.minecraft.banner.skull.lime": "Klopenn geotet sklaer",
  "block.minecraft.banner.skull.magenta": "Klopenn en mouareg",
  "block.minecraft.banner.skull.orange": "Klopenn en orañjezeg",
  "block.minecraft.banner.skull.pink": "Klopenn en-gwirion",
  "block.minecraft.banner.skull.purple": "Klopenn en mouk",
  "block.minecraft.banner.skull.red": "Klopenn en gul",
  "block.minecraft.banner.skull.white": "Klopenn en arc'hant",
  "block.minecraft.banner.skull.yellow": "Klopenn en aour",
  "block.minecraft.banner.small_stripes.black": "Pevar feul en sabel",
  "block.minecraft.banner.small_stripes.blue": "Pevar feul en glazur",
  "block.minecraft.banner.small_stripes.brown": "Pevar feul en tanneg",
  "block.minecraft.banner.small_stripes.cyan": "Pevar feul en sian",
  "block.minecraft.banner.small_stripes.gray": "Pevar feul en houarn",
  "block.minecraft.banner.small_stripes.green": "Pevar feul geotet",
  "block.minecraft.banner.small_stripes.light_blue": "Pevar feul en glazur sklaer",
  "block.minecraft.banner.small_stripes.light_gray": "Pevar feul en arc'hant gris",
  "block.minecraft.banner.small_stripes.lime": "Pevar feul geotet sklaer",
  "block.minecraft.banner.small_stripes.magenta": "Pevar feul en mouareg",
  "block.minecraft.banner.small_stripes.orange": "Pevar feul en orañjezeg",
  "block.minecraft.banner.small_stripes.pink": "Pevar feul en-gwirion",
  "block.minecraft.banner.small_stripes.purple": "Pevar feul en mouk",
  "block.minecraft.banner.small_stripes.red": "Pevar feul en gul",
  "block.minecraft.banner.small_stripes.white": "Pevar feul en arc'hant",
  "block.minecraft.banner.small_stripes.yellow": "Pevar feul en aour",
  "block.minecraft.banner.square_bottom_left.black": "Konk en sabel ouzh beg dehoù",
  "block.minecraft.banner.square_bottom_left.blue": "Konk en glazur ouzh beg dehoù",
  "block.minecraft.banner.square_bottom_left.brown": "Konk en tanneg ouzh beg dehoù",
  "block.minecraft.banner.square_bottom_left.cyan": "Konk en sian ouzh beg dehoù",
  "block.minecraft.banner.square_bottom_left.gray": "Konk en houarn ouzh beg dehoù",
  "block.minecraft.banner.square_bottom_left.green": "Konk geotet ouzh beg dehoù",
  "block.minecraft.banner.square_bottom_left.light_blue": "Konk en glazur sklaer ouzh beg dehoù",
  "block.minecraft.banner.square_bottom_left.light_gray": "Konk en arc'hant gris ouzh beg dehoù",
  "block.minecraft.banner.square_bottom_left.lime": "Konk geotet sklaer ouzh beg dehoù",
  "block.minecraft.banner.square_bottom_left.magenta": "Konk en mouareg ouzh beg dehoù",
  "block.minecraft.banner.square_bottom_left.orange": "Konk en orañjezeg ouzh beg dehoù",
  "block.minecraft.banner.square_bottom_left.pink": "Konk en-gwirion ouzh beg dehoù",
  "block.minecraft.banner.square_bottom_left.purple": "Konk en mouk ouzh beg dehoù",
  "block.minecraft.banner.square_bottom_left.red": "Konk en gul ouzh beg dehoù",
  "block.minecraft.banner.square_bottom_left.white": "Konk en arc'hant ouzh beg dehoù",
  "block.minecraft.banner.square_bottom_left.yellow": "Konk en aour ouzh beg dehoù",
  "block.minecraft.banner.square_bottom_right.black": "Konk en sabel ouzh beg kleiz",
  "block.minecraft.banner.square_bottom_right.blue": "Konk en glazur ouzh beg kleiz",
  "block.minecraft.banner.square_bottom_right.brown": "Konk en tanneg ouzh beg kleiz",
  "block.minecraft.banner.square_bottom_right.cyan": "Konk en sian ouzh beg kleiz",
  "block.minecraft.banner.square_bottom_right.gray": "Konk en houarn ouzh beg kleiz",
  "block.minecraft.banner.square_bottom_right.green": "Konk geotet ouzh beg kleiz",
  "block.minecraft.banner.square_bottom_right.light_blue": "Konk en glazur sklaer ouzh beg kleiz",
  "block.minecraft.banner.square_bottom_right.light_gray": "Konk en arc'hant gris ouzh beg kleiz",
  "block.minecraft.banner.square_bottom_right.lime": "Konk geotet sklaer ouzh beg kleiz",
  "block.minecraft.banner.square_bottom_right.magenta": "Konk en mouareg ouzh beg kleiz",
  "block.minecraft.banner.square_bottom_right.orange": "Konk en orañjezeg ouzh beg kleiz",
  "block.minecraft.banner.square_bottom_right.pink": "Konk en-gwirion ouzh beg kleiz",
  "block.minecraft.banner.square_bottom_right.purple": "Konk en mouk ouzh beg kleiz",
  "block.minecraft.banner.square_bottom_right.red": "Konk en gul ouzh beg kleiz",
  "block.minecraft.banner.square_bottom_right.white": "Konk en arc'hant ouzh beg kleiz",
  "block.minecraft.banner.square_bottom_right.yellow": "Konk en aour ouzh beg kleiz",
  "block.minecraft.banner.square_top_left.black": "Konk en sabel ouzh kab dehoù",
  "block.minecraft.banner.square_top_left.blue": "Konk en glazur ouzh kab dehoù",
  "block.minecraft.banner.square_top_left.brown": "Konk en tanneg ouzh kab dehoù",
  "block.minecraft.banner.square_top_left.cyan": "Konk en sian ouzh kab dehoù",
  "block.minecraft.banner.square_top_left.gray": "Konk en houarn ouzh kab dehoù",
  "block.minecraft.banner.square_top_left.green": "Konk geotet ouzh kab dehoù",
  "block.minecraft.banner.square_top_left.light_blue": "Konk en glazur sklaer ouzh kab dehoù",
  "block.minecraft.banner.square_top_left.light_gray": "Konk en arc'hant gris ouzh kab dehoù",
  "block.minecraft.banner.square_top_left.lime": "Konk geotet sklaer ouzh kab dehoù",
  "block.minecraft.banner.square_top_left.magenta": "Konk en mouareg ouzh kab dehoù",
  "block.minecraft.banner.square_top_left.orange": "Konk en orañjezeg ouzh kab dehoù",
  "block.minecraft.banner.square_top_left.pink": "Konk en-gwirion ouzh kab dehoù",
  "block.minecraft.banner.square_top_left.purple": "Konk en mouk ouzh kab dehoù",
  "block.minecraft.banner.square_top_left.red": "Konk en gul ouzh kab dehoù",
  "block.minecraft.banner.square_top_left.white": "Konk en arc'hant ouzh kab dehoù",
  "block.minecraft.banner.square_top_left.yellow": "Konk en aour ouzh kab dehoù",
  "block.minecraft.banner.square_top_right.black": "Konk en sabel ouzh kab kleiz",
  "block.minecraft.banner.square_top_right.blue": "Konk en glazur ouzh kab kleiz",
  "block.minecraft.banner.square_top_right.brown": "Konk en tanneg ouzh kab kleiz",
  "block.minecraft.banner.square_top_right.cyan": "Konk en sian ouzh kab kleiz",
  "block.minecraft.banner.square_top_right.gray": "Konk en houarn ouzh kab kleiz",
  "block.minecraft.banner.square_top_right.green": "Konk geotet ouzh kab kleiz",
  "block.minecraft.banner.square_top_right.light_blue": "Konk en glazur sklaer ouzh kab kleiz",
  "block.minecraft.banner.square_top_right.light_gray": "Konk en arc'hant gris ouzh kab kleiz",
  "block.minecraft.banner.square_top_right.lime": "Konk geotet sklaer ouzh kab kleiz",
  "block.minecraft.banner.square_top_right.magenta": "Konk en mouareg ouzh kab kleiz",
  "block.minecraft.banner.square_top_right.orange": "Konk en orañjezeg ouzh kab kleiz",
  "block.minecraft.banner.square_top_right.pink": "Konk en-gwirion ouzh kab kleiz",
  "block.minecraft.banner.square_top_right.purple": "Konk en mouk ouzh kab kleiz",
  "block.minecraft.banner.square_top_right.red": "Konk en gul ouzh kab kleiz",
  "block.minecraft.banner.square_top_right.white": "Konk en arc'hant ouzh kab kleiz",
  "block.minecraft.banner.square_top_right.yellow": "Konk en aour ouzh kab kleiz",
  "block.minecraft.banner.straight_cross.black": "Kroaz en sabel",
  "block.minecraft.banner.straight_cross.blue": "Kroaz en glazur",
  "block.minecraft.banner.straight_cross.brown": "Kroaz en tanneg",
  "block.minecraft.banner.straight_cross.cyan": "Kroaz en sian",
  "block.minecraft.banner.straight_cross.gray": "Kroaz en houarn",
  "block.minecraft.banner.straight_cross.green": "Kroaz geotet",
  "block.minecraft.banner.straight_cross.light_blue": "Kroaz en glazur sklaer",
  "block.minecraft.banner.straight_cross.light_gray": "Kroaz en arc'hant gris",
  "block.minecraft.banner.straight_cross.lime": "Kroaz geotet sklaer",
  "block.minecraft.banner.straight_cross.magenta": "Kroaz en mouareg",
  "block.minecraft.banner.straight_cross.orange": "Kroaz en orañjezeg",
  "block.minecraft.banner.straight_cross.pink": "Kroaz en-gwirion",
  "block.minecraft.banner.straight_cross.purple": "Kroaz en mouk",
  "block.minecraft.banner.straight_cross.red": "Kroaz en gul",
  "block.minecraft.banner.straight_cross.white": "Kroaz en arc'hant",
  "block.minecraft.banner.straight_cross.yellow": "Kroaz en aour",
  "block.minecraft.banner.stripe_bottom.black": "Tostal en sabel",
  "block.minecraft.banner.stripe_bottom.blue": "Tostal en glazur",
  "block.minecraft.banner.stripe_bottom.brown": "Tostal en tanneg",
  "block.minecraft.banner.stripe_bottom.cyan": "Tostal en sian",
  "block.minecraft.banner.stripe_bottom.gray": "Tostal en houarn",
  "block.minecraft.banner.stripe_bottom.green": "Tostal geotet",
  "block.minecraft.banner.stripe_bottom.light_blue": "Tostal en glazur sklaer",
  "block.minecraft.banner.stripe_bottom.light_gray": "Tostal en arc'hant gris",
  "block.minecraft.banner.stripe_bottom.lime": "Tostal geotet sklaer",
  "block.minecraft.banner.stripe_bottom.magenta": "Tostal en mouareg",
  "block.minecraft.banner.stripe_bottom.orange": "Tostal en orañjezeg",
  "block.minecraft.banner.stripe_bottom.pink": "Tostal en-gwirion",
  "block.minecraft.banner.stripe_bottom.purple": "Tostal en mouk",
  "block.minecraft.banner.stripe_bottom.red": "Tostal en gul",
  "block.minecraft.banner.stripe_bottom.white": "Tostal en arc'hant",
  "block.minecraft.banner.stripe_bottom.yellow": "Tostal en aour",
  "block.minecraft.banner.stripe_center.black": "Peul en sabel",
  "block.minecraft.banner.stripe_center.blue": "Peul en glazur",
  "block.minecraft.banner.stripe_center.brown": "Peul en tanneg",
  "block.minecraft.banner.stripe_center.cyan": "Peul en sian",
  "block.minecraft.banner.stripe_center.gray": "Peul en houarn",
  "block.minecraft.banner.stripe_center.green": "Peul geotet",
  "block.minecraft.banner.stripe_center.light_blue": "Peul en glazur sklaer",
  "block.minecraft.banner.stripe_center.light_gray": "Peul en arc'hant griz",
  "block.minecraft.banner.stripe_center.lime": "Peul geotet sklaer",
  "block.minecraft.banner.stripe_center.magenta": "Peul en mouareg",
  "block.minecraft.banner.stripe_center.orange": "Peul en orañjezeg",
  "block.minecraft.banner.stripe_center.pink": "Peul en-gwirion",
  "block.minecraft.banner.stripe_center.purple": "Peul en mouk",
  "block.minecraft.banner.stripe_center.red": "Peul en gul",
  "block.minecraft.banner.stripe_center.white": "Peul en arc'hant",
  "block.minecraft.banner.stripe_center.yellow": "Peul en aour",
  "block.minecraft.banner.stripe_downleft.black": "Bandenn en sabel kleiz",
  "block.minecraft.banner.stripe_downleft.blue": "Bandenn en glazur kleiz",
  "block.minecraft.banner.stripe_downleft.brown": "Bandenn en tanneg kleiz",
  "block.minecraft.banner.stripe_downleft.cyan": "Bandenn en sian kleiz",
  "block.minecraft.banner.stripe_downleft.gray": "Bandenn en houarn kleiz",
  "block.minecraft.banner.stripe_downleft.green": "Bandenn geotet kleiz",
  "block.minecraft.banner.stripe_downleft.light_blue": "Bandenn en glazur sklaer kleiz",
  "block.minecraft.banner.stripe_downleft.light_gray": "Bandenn en arc'hant gris kleiz",
  "block.minecraft.banner.stripe_downleft.lime": "Bandenn geotet sklaer kleiz",
  "block.minecraft.banner.stripe_downleft.magenta": "Bandenn en mouareg kleiz",
  "block.minecraft.banner.stripe_downleft.orange": "Bandenn en orañjezeg kleiz",
  "block.minecraft.banner.stripe_downleft.pink": "Bandenn en-gwirion kleiz",
  "block.minecraft.banner.stripe_downleft.purple": "Bandenn en mouk kleiz",
  "block.minecraft.banner.stripe_downleft.red": "Bandenn en gul kleiz",
  "block.minecraft.banner.stripe_downleft.white": "Bandenn en arc'hant kleiz",
  "block.minecraft.banner.stripe_downleft.yellow": "Bandenn en aour kleiz",
  "block.minecraft.banner.stripe_downright.black": "Bandenn en sabel",
  "block.minecraft.banner.stripe_downright.blue": "Bandenn en glazur",
  "block.minecraft.banner.stripe_downright.brown": "Bandenn en tanneg",
  "block.minecraft.banner.stripe_downright.cyan": "Bandenn en sian",
  "block.minecraft.banner.stripe_downright.gray": "Bandenn en houarn",
  "block.minecraft.banner.stripe_downright.green": "Bandenn geotet",
  "block.minecraft.banner.stripe_downright.light_blue": "Bandenn en glazur sklaer",
  "block.minecraft.banner.stripe_downright.light_gray": "Bandenn en arc'hant gris",
  "block.minecraft.banner.stripe_downright.lime": "Bandenn geotet sklaer",
  "block.minecraft.banner.stripe_downright.magenta": "Bandenn en mouareg",
  "block.minecraft.banner.stripe_downright.orange": "Bandenn en orañjezeg",
  "block.minecraft.banner.stripe_downright.pink": "Bandenn en-gwirion",
  "block.minecraft.banner.stripe_downright.purple": "Bandenn en mouk",
  "block.minecraft.banner.stripe_downright.red": "Bandenn en gul",
  "block.minecraft.banner.stripe_downright.white": "Bandenn en arc'hant",
  "block.minecraft.banner.stripe_downright.yellow": "Bandenn en aour",
  "block.minecraft.banner.stripe_left.black": "Peul en sabel dehoù",
  "block.minecraft.banner.stripe_left.blue": "Peul en glazur dehoù",
  "block.minecraft.banner.stripe_left.brown": "Peul en tanneg dehoù",
  "block.minecraft.banner.stripe_left.cyan": "Peul en sian dehoù",
  "block.minecraft.banner.stripe_left.gray": "Peul en houarn dehoù",
  "block.minecraft.banner.stripe_left.green": "Peul geotet dehoù",
  "block.minecraft.banner.stripe_left.light_blue": "Peul en glazur sklaer dehoù",
  "block.minecraft.banner.stripe_left.light_gray": "Peul en arc'hant gris dehoù",
  "block.minecraft.banner.stripe_left.lime": "Peul geotet sklaer dehoù",
  "block.minecraft.banner.stripe_left.magenta": "Peul en mouareg dehoù",
  "block.minecraft.banner.stripe_left.orange": "Peul en orañjezeg dehoù",
  "block.minecraft.banner.stripe_left.pink": "Peul en-gwirion dehoù",
  "block.minecraft.banner.stripe_left.purple": "Peul en mouk dehoù",
  "block.minecraft.banner.stripe_left.red": "Peul en gul dehoù",
  "block.minecraft.banner.stripe_left.white": "Peul en arc'hant dehoù",
  "block.minecraft.banner.stripe_left.yellow": "Peul en aour dehoù",
  "block.minecraft.banner.stripe_middle.black": "Treustell en sabel",
  "block.minecraft.banner.stripe_middle.blue": "Treustell en glazur",
  "block.minecraft.banner.stripe_middle.brown": "Treustell en tanneg",
  "block.minecraft.banner.stripe_middle.cyan": "Treustell en sian",
  "block.minecraft.banner.stripe_middle.gray": "Treustell en houarn",
  "block.minecraft.banner.stripe_middle.green": "Treustell geotet",
  "block.minecraft.banner.stripe_middle.light_blue": "Treustell en glazur sklaer",
  "block.minecraft.banner.stripe_middle.light_gray": "Treustell en arc'hant gris",
  "block.minecraft.banner.stripe_middle.lime": "Treustell geotet sklaer",
  "block.minecraft.banner.stripe_middle.magenta": "Treustell en mouareg",
  "block.minecraft.banner.stripe_middle.orange": "Treustell en orañjezeg",
  "block.minecraft.banner.stripe_middle.pink": "Treustell en-gwirion",
  "block.minecraft.banner.stripe_middle.purple": "Treustell en mouk",
  "block.minecraft.banner.stripe_middle.red": "Treustell en gul",
  "block.minecraft.banner.stripe_middle.white": "Treustell en arc'hant",
  "block.minecraft.banner.stripe_middle.yellow": "Treustell en aour",
  "block.minecraft.banner.stripe_right.black": "Peul en sabel kleiz",
  "block.minecraft.banner.stripe_right.blue": "Peul en glazur kleiz",
  "block.minecraft.banner.stripe_right.brown": "Peul en tanneg kleiz",
  "block.minecraft.banner.stripe_right.cyan": "Peul en sian kleiz",
  "block.minecraft.banner.stripe_right.gray": "Peul en houarn kleiz",
  "block.minecraft.banner.stripe_right.green": "Peul geotet kleiz",
  "block.minecraft.banner.stripe_right.light_blue": "Peul en glazur sklaer kleiz",
  "block.minecraft.banner.stripe_right.light_gray": "Peul en arc'hant gris kleiz",
  "block.minecraft.banner.stripe_right.lime": "Peul geotet sklaer kleiz",
  "block.minecraft.banner.stripe_right.magenta": "Peul en mouareg kleiz",
  "block.minecraft.banner.stripe_right.orange": "Peul en orañjezeg kleiz",
  "block.minecraft.banner.stripe_right.pink": "Peul en-gwirion kleiz",
  "block.minecraft.banner.stripe_right.purple": "Peul en mouk kleiz",
  "block.minecraft.banner.stripe_right.red": "Peul en gul kleiz",
  "block.minecraft.banner.stripe_right.white": "Peul en arc'hant kleiz",
  "block.minecraft.banner.stripe_right.yellow": "Peul en aour kleiz",
  "block.minecraft.banner.stripe_top.black": "Kab en sabel",
  "block.minecraft.banner.stripe_top.blue": "Kab en glazur",
  "block.minecraft.banner.stripe_top.brown": "Kab en tanneg",
  "block.minecraft.banner.stripe_top.cyan": "Kab en sian",
  "block.minecraft.banner.stripe_top.gray": "Kab en houarn",
  "block.minecraft.banner.stripe_top.green": "Kab geotet",
  "block.minecraft.banner.stripe_top.light_blue": "Kab en glazur sklaer",
  "block.minecraft.banner.stripe_top.light_gray": "Kab en arc'hant gris",
  "block.minecraft.banner.stripe_top.lime": "Kab geotet sklaer",
  "block.minecraft.banner.stripe_top.magenta": "Kab en mouareg",
  "block.minecraft.banner.stripe_top.orange": "Kab en orañjezeg",
  "block.minecraft.banner.stripe_top.pink": "Kab en-gwirion",
  "block.minecraft.banner.stripe_top.purple": "Kab en mouk",
  "block.minecraft.banner.stripe_top.red": "Kab en gul",
  "block.minecraft.banner.stripe_top.white": "Kab en arc'hant",
  "block.minecraft.banner.stripe_top.yellow": "Kab en aour",
  "block.minecraft.banner.triangle_bottom.black": "Mantellet en sabel",
  "block.minecraft.banner.triangle_bottom.blue": "Mantellet en glazur",
  "block.minecraft.banner.triangle_bottom.brown": "Mantellet en tanneg",
  "block.minecraft.banner.triangle_bottom.cyan": "Mantellet en sian",
  "block.minecraft.banner.triangle_bottom.gray": "Mantellet en houarn",
  "block.minecraft.banner.triangle_bottom.green": "Mantellet geotet",
  "block.minecraft.banner.triangle_bottom.light_blue": "Mantellet en glazur sklaer",
  "block.minecraft.banner.triangle_bottom.light_gray": "Mantellet en arc'hant gris",
  "block.minecraft.banner.triangle_bottom.lime": "Mantellet geotet sklaer",
  "block.minecraft.banner.triangle_bottom.magenta": "Mantellet en mouareg",
  "block.minecraft.banner.triangle_bottom.orange": "Mantellet en orañjezeg",
  "block.minecraft.banner.triangle_bottom.pink": "Mantellet en-gwirion",
  "block.minecraft.banner.triangle_bottom.purple": "Mantellet en mouk",
  "block.minecraft.banner.triangle_bottom.red": "Mantellet en gul",
  "block.minecraft.banner.triangle_bottom.white": "Mantellet en arc'hant",
  "block.minecraft.banner.triangle_bottom.yellow": "Mantellet en aour",
  "block.minecraft.banner.triangle_top.black": "Mantellet en sabel c'hweniet",
  "block.minecraft.banner.triangle_top.blue": "Mantellet en glazur c'hweniet",
  "block.minecraft.banner.triangle_top.brown": "Mantellet en tanneg c'hweniet",
  "block.minecraft.banner.triangle_top.cyan": "Mantellet en sian c'hweniet",
  "block.minecraft.banner.triangle_top.gray": "Mantellet en houarn c'hweniet",
  "block.minecraft.banner.triangle_top.green": "Mantellet geotet c'hweniet",
  "block.minecraft.banner.triangle_top.light_blue": "Mantellet en glazur sklaer c'hweniet",
  "block.minecraft.banner.triangle_top.light_gray": "Mantellet en arc'hant gris c'hweniet",
  "block.minecraft.banner.triangle_top.lime": "Mantellet geotet sklaer c'hweniet",
  "block.minecraft.banner.triangle_top.magenta": "Mantellet en mouareg c'hweniet",
  "block.minecraft.banner.triangle_top.orange": "Mantellet en orañjezeg c'hweniet",
  "block.minecraft.banner.triangle_top.pink": "Mantellet en-gwirion c'hweniet",
  "block.minecraft.banner.triangle_top.purple": "Mantellet en mouk c'hweniet",
  "block.minecraft.banner.triangle_top.red": "Mantellet en gul c'hweniet",
  "block.minecraft.banner.triangle_top.white": "Mantellet en arc'hant c'hweniet",
  "block.minecraft.banner.triangle_top.yellow": "Mantellet en aour c'hweniet",
  "block.minecraft.banner.triangles_bottom.black": "Milginoù en sabel ouzh beg",
  "block.minecraft.banner.triangles_bottom.blue": "Milginoù en glazur ouzh beg",
  "block.minecraft.banner.triangles_bottom.brown": "Milginoù en tanneg ouzh beg",
  "block.minecraft.banner.triangles_bottom.cyan": "Milginoù en sian ouzh beg",
  "block.minecraft.banner.triangles_bottom.gray": "Milginoù en houarn ouzh beg",
  "block.minecraft.banner.triangles_bottom.green": "Milginoù geotet ouzh beg",
  "block.minecraft.banner.triangles_bottom.light_blue": "Milginoù en glazur sklaer ouzh beg",
  "block.minecraft.banner.triangles_bottom.light_gray": "Milginoù en arc'hant gris ouzh beg",
  "block.minecraft.banner.triangles_bottom.lime": "Milginoù geotet sklaer ouzh beg",
  "block.minecraft.banner.triangles_bottom.magenta": "Milginoù en mouareg ouzh beg",
  "block.minecraft.banner.triangles_bottom.orange": "Milginoù en orañjezeg ouzh beg",
  "block.minecraft.banner.triangles_bottom.pink": "Milginoù en-gwirion ouzh beg",
  "block.minecraft.banner.triangles_bottom.purple": "Milginoù en mouk ouzh beg",
  "block.minecraft.banner.triangles_bottom.red": "Milginoù en gul ouzh beg",
  "block.minecraft.banner.triangles_bottom.white": "Milginoù en arc'hant ouzh beg",
  "block.minecraft.banner.triangles_bottom.yellow": "Milginoù en aour ouzh beg",
  "block.minecraft.banner.triangles_top.black": "Milginoù en sabel ouzh kab",
  "block.minecraft.banner.triangles_top.blue": "Milginoù en glazur ouzh kab",
  "block.minecraft.banner.triangles_top.brown": "Milginoù en tanneg ouzh kab",
  "block.minecraft.banner.triangles_top.cyan": "Milginoù en sian ouzh kab",
  "block.minecraft.banner.triangles_top.gray": "Milginoù en houarn ouzh kab",
  "block.minecraft.banner.triangles_top.green": "Milginoù geotet ouzh kab",
  "block.minecraft.banner.triangles_top.light_blue": "Milginoù en glazur sklaer ouzh kab",
  "block.minecraft.banner.triangles_top.light_gray": "Milginoù en arc'hant gris ouzh kab",
  "block.minecraft.banner.triangles_top.lime": "Milginoù geotet sklaer ouzh kab",
  "block.minecraft.banner.triangles_top.magenta": "Milginoù en mouareg ouzh kab",
  "block.minecraft.banner.triangles_top.orange": "Milginoù en orañjezeg ouzh kab",
  "block.minecraft.banner.triangles_top.pink": "Milginoù en-gwirion ouzh kab",
  "block.minecraft.banner.triangles_top.purple": "Milginoù en mouk ouzh kab",
  "block.minecraft.banner.triangles_top.red": "Milginoù en gul ouzh kab",
  "block.minecraft.banner.triangles_top.white": "Milginoù en arc'hant ouzh kab",
  "block.minecraft.banner.triangles_top.yellow": "Milginoù en aour ouzh kab",
  "block.minecraft.barrel": "Tonell",
  "block.minecraft.barrier": "Harz",
  "block.minecraft.basalt": "Bazalt",
  "block.minecraft.beacon": "Balizenn",
  "block.minecraft.beacon.primary": "Galloud pennañ",
  "block.minecraft.beacon.secondary": "Eil galloud",
  "block.minecraft.bed.no_sleep": "N'hallit kousket nemet diouzh an noz hag e-pad un arnev",
  "block.minecraft.bed.not_safe": "N'hallit ket kousket bremañ, euzhviled a zo nepell",
  "block.minecraft.bed.obstructed": "Stanket eo ar gwele",
  "block.minecraft.bed.occupied": "Ac'hubet eo ar gwele",
  "block.minecraft.bed.too_far_away": "N'hallit ket kousket bremañ, re bell emañ ar gwele",
  "block.minecraft.bedrock": "Roc'h-gwele",
  "block.minecraft.bee_nest": "Ruskenn",
  "block.minecraft.beehive": "Koloenn",
  "block.minecraft.beetroots": "Beterabez",
  "block.minecraft.bell": "Kloc'h",
  "block.minecraft.big_dripleaf": "Dourzelienn vras",
  "block.minecraft.big_dripleaf_stem": "Korzenn dourzelienn vras",
  "block.minecraft.birch_button": "Bouton bezv",
  "block.minecraft.birch_door": "Dor vezv",
  "block.minecraft.birch_fence": "Kloued vezv",
  "block.minecraft.birch_fence_gate": "Dorikell vezv",
  "block.minecraft.birch_hanging_sign": "Panell vezv a-ispilh",
  "block.minecraft.birch_leaves": "Delioù bezv",
  "block.minecraft.birch_log": "Etev bezv",
  "block.minecraft.birch_planks": "Plankennoù bezv",
  "block.minecraft.birch_pressure_plate": "Plakenn wask bezv",
  "block.minecraft.birch_sapling": "Strujenn vezv",
  "block.minecraft.birch_shelf": "Stalenn vezv",
  "block.minecraft.birch_sign": "Panell vezv",
  "block.minecraft.birch_slab": "Dar vezv",
  "block.minecraft.birch_stairs": "Diri bezv",
  "block.minecraft.birch_trapdoor": "Trap bezv",
  "block.minecraft.birch_wall_hanging_sign": "Panell-voger vezv a-ispilh",
  "block.minecraft.birch_wall_sign": "Panell-voger vezv",
  "block.minecraft.birch_wood": "Koad bezv",
  "block.minecraft.black_banner": "Banniel du",
  "block.minecraft.black_bed": "Gwele du",
  "block.minecraft.black_candle": "Boujienn zu",
  "block.minecraft.black_candle_cake": "Gwastell gant ur voujienn zu",
  "block.minecraft.black_carpet": "Pallenn du",
  "block.minecraft.black_concrete": "Betoñs du",
  "block.minecraft.black_concrete_powder": "Poultr betoñs du",
  "block.minecraft.black_glazed_terracotta": "Pri poazh amailhet du",
  "block.minecraft.black_shulker_box": "Boest Shulker du",
  "block.minecraft.black_stained_glass": "Gwer du",
  "block.minecraft.black_stained_glass_pane": "Gwerenn zu",
  "block.minecraft.black_terracotta": "Pri poazh du",
  "block.minecraft.black_wool": "Gloan du",
  "block.minecraft.blackstone": "Maen-du",
  "block.minecraft.blackstone_slab": "Dar vaen-du",
  "block.minecraft.blackstone_stairs": "Diri maen-du",
  "block.minecraft.blackstone_wall": "Moger vaen-du",
  "block.minecraft.blast_furnace": "Uhelforn",
  "block.minecraft.blue_banner": "Banniel glas",
  "block.minecraft.blue_bed": "Gwele glas",
  "block.minecraft.blue_candle": "Boujienn c'hlas",
  "block.minecraft.blue_candle_cake": "Gwastell gant ur voujienn c'hlas",
  "block.minecraft.blue_carpet": "Pallenn glas",
  "block.minecraft.blue_concrete": "Betoñs glas",
  "block.minecraft.blue_concrete_powder": "Poultr betoñs glas",
  "block.minecraft.blue_glazed_terracotta": "Pri poazh amailhet glas",
  "block.minecraft.blue_ice": "Skorn glas",
  "block.minecraft.blue_orchid": "Orkideenn c'hlas",
  "block.minecraft.blue_shulker_box": "Boest Shulker glas",
  "block.minecraft.blue_stained_glass": "Gwer glas",
  "block.minecraft.blue_stained_glass_pane": "Gwerenn c'hlas",
  "block.minecraft.blue_terracotta": "Pri poazh glas",
  "block.minecraft.blue_wool": "Gloan glas",
  "block.minecraft.bone_block": "Bloc'h eskern",
  "block.minecraft.bookshelf": "Levraoueg",
  "block.minecraft.brain_coral": "Koural empenn",
  "block.minecraft.brain_coral_block": "Bloc'h koural empenn",
  "block.minecraft.brain_coral_fan": "Aveler koural empenn",
  "block.minecraft.brain_coral_wall_fan": "Aveler moger koural empenn",
  "block.minecraft.brewing_stand": "Lambig",
  "block.minecraft.brick_slab": "Dar brikennoù",
  "block.minecraft.brick_stairs": "Diri brikennoù",
  "block.minecraft.brick_wall": "Moger brikennoù",
  "block.minecraft.bricks": "Brikennoù",
  "block.minecraft.brown_banner": "Banniel gell",
  "block.minecraft.brown_bed": "Gwele gell",
  "block.minecraft.brown_candle": "Boujienn c'hell",
  "block.minecraft.brown_candle_cake": "Gwastell gant ur voujienn c'hell",
  "block.minecraft.brown_carpet": "Pallenn gell",
  "block.minecraft.brown_concrete": "Betoñs gell",
  "block.minecraft.brown_concrete_powder": "Poultr betoñs gell",
  "block.minecraft.brown_glazed_terracotta": "Pri poazh amailhet gell",
  "block.minecraft.brown_mushroom": "Kabell-touseg gell",
  "block.minecraft.brown_mushroom_block": "Bloc'h kabell-touseg gell",
  "block.minecraft.brown_shulker_box": "Boest Shulker c'hell",
  "block.minecraft.brown_stained_glass": "Gwer gell",
  "block.minecraft.brown_stained_glass_pane": "Gwerenn c'hell",
  "block.minecraft.brown_terracotta": "Pri poazh gell",
  "block.minecraft.brown_wool": "Gloan gell",
  "block.minecraft.bubble_column": "Kolonenn glogor",
  "block.minecraft.bubble_coral": "Koural klogor",
  "block.minecraft.bubble_coral_block": "Bloc'h koural klogor",
  "block.minecraft.bubble_coral_fan": "Aveler koural klogor",
  "block.minecraft.bubble_coral_wall_fan": "Aveler moger koural klogor",
  "block.minecraft.budding_amethyst": "Bloc'h broñsañ ametist",
  "block.minecraft.bush": "Bodenn",
  "block.minecraft.cactus": "Kaktuz",
  "block.minecraft.cactus_flower": "Bleunienn gaktuz",
  "block.minecraft.cake": "Gwastell",
  "block.minecraft.calcite": "Kalsit",
  "block.minecraft.calibrated_sculk_sensor": "Diguzher Sculk gobariet",
  "block.minecraft.campfire": "Tan kamp",
  "block.minecraft.candle": "Boujienn",
  "block.minecraft.candle_cake": "Gwastell gant ur voujienn",
  "block.minecraft.carrots": "Karotez",
  "block.minecraft.cartography_table": "Taol gartennouriezh",
  "block.minecraft.carved_pumpkin": "Sitrouilhezenn kizellet",
  "block.minecraft.cauldron": "Kaoter",
  "block.minecraft.cave_air": "Aer mougev",
  "block.minecraft.cave_vines": "Lianennoù ar mougevioù",
  "block.minecraft.cave_vines_plant": "Plant lianennoù ar mougevioù",
  "block.minecraft.chain": "Chadenn",
  "block.minecraft.chain_command_block": "Bloc'h chadenn urzhiañ",
  "block.minecraft.cherry_button": "Bouton koad-kerez",
  "block.minecraft.cherry_door": "Dor koad-kerez",
  "block.minecraft.cherry_fence": "Kloued koad-kerez",
  "block.minecraft.cherry_fence_gate": "Dorikell koad-kerez",
  "block.minecraft.cherry_hanging_sign": "Panell koad-kerez a-ispilh",
  "block.minecraft.cherry_leaves": "Delioù gwez-kerez",
  "block.minecraft.cherry_log": "Kef gwez-kerez",
  "block.minecraft.cherry_planks": "Plankennoù koad-kerez",
  "block.minecraft.cherry_pressure_plate": "Plakenn wask koad-kerez",
  "block.minecraft.cherry_sapling": "Strujenn wez-kerez",
  "block.minecraft.cherry_shelf": "Stalenn koad kerez",
  "block.minecraft.cherry_sign": "Panell koad-kerez",
  "block.minecraft.cherry_slab": "Dar koad-kerez",
  "block.minecraft.cherry_stairs": "Diri koad-kerez",
  "block.minecraft.cherry_trapdoor": "Trap koad-kerez",
  "block.minecraft.cherry_wall_hanging_sign": "Panell-voger koad-kerez a-ispilh",
  "block.minecraft.cherry_wall_sign": "Panell-voger koad-kerez",
  "block.minecraft.cherry_wood": "Koad-kerez",
  "block.minecraft.chest": "Koufr",
  "block.minecraft.chipped_anvil": "Annev boulc'het",
  "block.minecraft.chiseled_bookshelf": "Levraoueg kizellet",
  "block.minecraft.chiseled_copper": "Kouevr kizellet",
  "block.minecraft.chiseled_deepslate": "Maen-glas an isfont kizellet",
  "block.minecraft.chiseled_nether_bricks": "Brikennoù an Nether kizellet",
  "block.minecraft.chiseled_polished_blackstone": "Maen-du flour kizellet",
  "block.minecraft.chiseled_quartz_block": "Bloc'h kouarz kizellet",
  "block.minecraft.chiseled_red_sandstone": "Maen-krag ruz kizellet",
  "block.minecraft.chiseled_resin_bricks": "Brikennoù rousin kizellet",
  "block.minecraft.chiseled_sandstone": "Maen-krag kizellet",
  "block.minecraft.chiseled_stone_bricks": "Brikennoù roc'h kizellet",
  "block.minecraft.chiseled_tuff": "Tuf kizellet",
  "block.minecraft.chiseled_tuff_bricks": "Brikennoù tuf benet",
  "block.minecraft.chorus_flower": "Bleunienn gorus",
  "block.minecraft.chorus_plant": "Plantenn gorus",
  "block.minecraft.clay": "Pri",
  "block.minecraft.closed_eyeblossom": "Bleunienn-lagad serr",
  "block.minecraft.coal_block": "Bloc'h glaou",
  "block.minecraft.coal_ore": "Kailh glaou",
  "block.minecraft.coarse_dirt": "Douar losket",
  "block.minecraft.cobbled_deepslate": "Maen an isfont",
  "block.minecraft.cobbled_deepslate_slab": "Dar maen an isfont",
  "block.minecraft.cobbled_deepslate_stairs": "Diri maen an isfont",
  "block.minecraft.cobbled_deepslate_wall": "Moger maen an isfont",
  "block.minecraft.cobblestone": "Maen",
  "block.minecraft.cobblestone_slab": "Dar maen",
  "block.minecraft.cobblestone_stairs": "Diri maen",
  "block.minecraft.cobblestone_wall": "Moger vaen",
  "block.minecraft.cobweb": "Gwiad kevnidenn",
  "block.minecraft.cocoa": "Kakao",
  "block.minecraft.command_block": "Bloc'h urzhiañ",
  "block.minecraft.comparator": "Keñverier Redstone",
  "block.minecraft.composter": "Rotel",
  "block.minecraft.conduit": "San",
  "block.minecraft.copper_bars": "Barrennoù kouevr",
  "block.minecraft.copper_block": "Bloc'h Kouevr",
  "block.minecraft.copper_bulb": "Kleuzeur gouevr",
  "block.minecraft.copper_chain": "Chadenn gouevr",
  "block.minecraft.copper_chest": "Stalenn gouevr",
  "block.minecraft.copper_door": "Dor gouevr",
  "block.minecraft.copper_golem_statue": "Delwenn golem kouevr",
  "block.minecraft.copper_grate": "Kael gouevr",
  "block.minecraft.copper_lantern": "Letern kouevr",
  "block.minecraft.copper_ore": "Kailh kouevr",
  "block.minecraft.copper_torch": "Etev-gouloù kouevr",
  "block.minecraft.copper_trapdoor": "Trap kouevr",
  "block.minecraft.copper_wall_torch": "Etev-gouloù moger kouevr",
  "block.minecraft.cornflower": "Glizinenn",
  "block.minecraft.cracked_deepslate_bricks": "Brikennoù maen-glas an isfont faoutet",
  "block.minecraft.cracked_deepslate_tiles": "Maen-glas an isfont karrellet faoutet",
  "block.minecraft.cracked_nether_bricks": "Brikennoù an Nether faout",
  "block.minecraft.cracked_polished_blackstone_bricks": "Maen-du benet lufret faout",
  "block.minecraft.cracked_stone_bricks": "Brikennoù roc'h faout",
  "block.minecraft.crafter": "Aozer",
  "block.minecraft.crafting_table": "Taol aozañ",
  "block.minecraft.creaking_heart": "Kalon ar gwigour",
  "block.minecraft.creeper_head": "Penn Creeper",
  "block.minecraft.creeper_wall_head": "Penn Creeper moger",
  "block.minecraft.crimson_button": "Bouton ruz-tane",
  "block.minecraft.crimson_door": "Dor ruz tane",
  "block.minecraft.crimson_fence": "Kloued ruz-tane",
  "block.minecraft.crimson_fence_gate": "Dorikell ruz-tane",
  "block.minecraft.crimson_fungus": "Kabell-touseg ruz-tane",
  "block.minecraft.crimson_hanging_sign": "Panell ruz-tane a-ispilh",
  "block.minecraft.crimson_hyphae": "Hifennoù ruz-tane",
  "block.minecraft.crimson_nylium": "Niliom ruz-tane",
  "block.minecraft.crimson_planks": "Plankennoù ruz-tane",
  "block.minecraft.crimson_pressure_plate": "Plakenn wask ruz-tane",
  "block.minecraft.crimson_roots": "Gwrizioù ruz-tane",
  "block.minecraft.crimson_shelf": "Stalenn ruz-tane",
  "block.minecraft.crimson_sign": "Panell ruz-tane",
  "block.minecraft.crimson_slab": "Dar ruz-tane",
  "block.minecraft.crimson_stairs": "Diri ruz-tane",
  "block.minecraft.crimson_stem": "Korzenn ruz-tane",
  "block.minecraft.crimson_trapdoor": "Trap ruz-tane",
  "block.minecraft.crimson_wall_hanging_sign": "Panell-voger ruz-tane a-ispilh",
  "block.minecraft.crimson_wall_sign": "Panell-voger ruz-tane",
  "block.minecraft.crying_obsidian": "Obsidian goueler",
  "block.minecraft.cut_copper": "Kouevr benet",
  "block.minecraft.cut_copper_slab": "Dar gouevr benet",
  "block.minecraft.cut_copper_stairs": "Diri kouevr benet",
  "block.minecraft.cut_red_sandstone": "Maen-krag ruz benet",
  "block.minecraft.cut_red_sandstone_slab": "Dar vaen-krag ruz benet",
  "block.minecraft.cut_sandstone": "Maen-krag benet",
  "block.minecraft.cut_sandstone_slab": "Dar vaen-krag benet",
  "block.minecraft.cyan_banner": "Banniel sian",
  "block.minecraft.cyan_bed": "Gwele sian",
  "block.minecraft.cyan_candle": "Boujienn sian",
  "block.minecraft.cyan_candle_cake": "Gwastell gant ur voujienn sian",
  "block.minecraft.cyan_carpet": "Pallenn sian",
  "block.minecraft.cyan_concrete": "Betoñs sian",
  "block.minecraft.cyan_concrete_powder": "Poultr betoñs sian",
  "block.minecraft.cyan_glazed_terracotta": "Pri poazh amailhet sian",
  "block.minecraft.cyan_shulker_box": "Boest Shulker sian",
  "block.minecraft.cyan_stained_glass": "Gwer sian",
  "block.minecraft.cyan_stained_glass_pane": "Gwerenn sian",
  "block.minecraft.cyan_terracotta": "Pri poazh sian",
  "block.minecraft.cyan_wool": "Gloan sian",
  "block.minecraft.damaged_anvil": "Annev gwallaozet",
  "block.minecraft.dandelion": "C'hwervizon",
  "block.minecraft.dark_oak_button": "Bouton derv teñval",
  "block.minecraft.dark_oak_door": "Dor zerv teñval",
  "block.minecraft.dark_oak_fence": "Kloued derv teñval",
  "block.minecraft.dark_oak_fence_gate": "Dorikell derv teñval",
  "block.minecraft.dark_oak_hanging_sign": "Panell derv teñval a-ispilh",
  "block.minecraft.dark_oak_leaves": "Delioù derv teñval",
  "block.minecraft.dark_oak_log": "Etev derv teñval",
  "block.minecraft.dark_oak_planks": "Plankennoù derv teñval",
  "block.minecraft.dark_oak_pressure_plate": "Plakenn wask derv teñval",
  "block.minecraft.dark_oak_sapling": "Strujenn derv teñval",
  "block.minecraft.dark_oak_shelf": "Stalenn derv teñval",
  "block.minecraft.dark_oak_sign": "Panell derv teñval",
  "block.minecraft.dark_oak_slab": "Dar derv teñval",
  "block.minecraft.dark_oak_stairs": "Diri derv teñval",
  "block.minecraft.dark_oak_trapdoor": "Trap derv teñval",
  "block.minecraft.dark_oak_wall_hanging_sign": "Panell derv-teñval a-ispilh",
  "block.minecraft.dark_oak_wall_sign": "Panell-voger derv teñval",
  "block.minecraft.dark_oak_wood": "Koad derv teñval",
  "block.minecraft.dark_prismarine": "Prismarine teñval",
  "block.minecraft.dark_prismarine_slab": "Dar prismarine teñval",
  "block.minecraft.dark_prismarine_stairs": "Diri prismarine teñval",
  "block.minecraft.daylight_detector": "Dinoer gouloù an deiz",
  "block.minecraft.dead_brain_coral": "Koural empenn marv",
  "block.minecraft.dead_brain_coral_block": "Bloc'h koural empenn marv",
  "block.minecraft.dead_brain_coral_fan": "Aveler koural empenn marv",
  "block.minecraft.dead_brain_coral_wall_fan": "Aveler moger koural empenn marv",
  "block.minecraft.dead_bubble_coral": "Koural klogor marv",
  "block.minecraft.dead_bubble_coral_block": "Bloc'h koural klogor marv",
  "block.minecraft.dead_bubble_coral_fan": "Aveler koural klogor marv",
  "block.minecraft.dead_bubble_coral_wall_fan": "Aveler moger koural klogor marv",
  "block.minecraft.dead_bush": "Bod marv",
  "block.minecraft.dead_fire_coral": "Koural tan marv",
  "block.minecraft.dead_fire_coral_block": "Bloc'h koural tan marv",
  "block.minecraft.dead_fire_coral_fan": "Aveler koural tan marv",
  "block.minecraft.dead_fire_coral_wall_fan": "Aveler moger koural tan marv",
  "block.minecraft.dead_horn_coral": "Koural kerniel marv",
  "block.minecraft.dead_horn_coral_block": "Bloc'h koural kerniel marv",
  "block.minecraft.dead_horn_coral_fan": "Aveler koural kerniel marv",
  "block.minecraft.dead_horn_coral_wall_fan": "Aveler moger koural kerniel marv",
  "block.minecraft.dead_tube_coral": "Koural korzennek marv",
  "block.minecraft.dead_tube_coral_block": "Bloc'h koural korzennek marv",
  "block.minecraft.dead_tube_coral_fan": "Aveler koural korzennek marv",
  "block.minecraft.dead_tube_coral_wall_fan": "Aveler moger koural korzennek marv",
  "block.minecraft.decorated_pot": "Pod kinklet",
  "block.minecraft.deepslate": "Maen-glas an isfont",
  "block.minecraft.deepslate_brick_slab": "Dar maen-glas an isfont benet",
  "block.minecraft.deepslate_brick_stairs": "Diri maen-glas an isfont benet",
  "block.minecraft.deepslate_brick_wall": "Moger maen-glas an isfont benet",
  "block.minecraft.deepslate_bricks": "Brikennoù maen-glas an isfont",
  "block.minecraft.deepslate_coal_ore": "Kailh glaou an isfont",
  "block.minecraft.deepslate_copper_ore": "Kailh kouevr an isfont",
  "block.minecraft.deepslate_diamond_ore": "Kailh diamant an isfont",
  "block.minecraft.deepslate_emerald_ore": "Kailh emrodez an isfont",
  "block.minecraft.deepslate_gold_ore": "Kailh aour an isfont",
  "block.minecraft.deepslate_iron_ore": "Kailh houarn an isfont",
  "block.minecraft.deepslate_lapis_ore": "Kailh Lapis Lazuli an isfont",
  "block.minecraft.deepslate_redstone_ore": "Kailh Redstone an isfont",
  "block.minecraft.deepslate_tile_slab": "Dar maen-glas an isfont karrellet",
  "block.minecraft.deepslate_tile_stairs": "Diri maen-glas an isfont karrellet",
  "block.minecraft.deepslate_tile_wall": "Moger maen-glas an isfont karrellet",
  "block.minecraft.deepslate_tiles": "Maen-glas an isfont karrellet",
  "block.minecraft.detector_rail": "Hent-houarn dinoer",
  "block.minecraft.diamond_block": "Bloc'h diamant",
  "block.minecraft.diamond_ore": "Kailh diamant",
  "block.minecraft.diorite": "Diorit",
  "block.minecraft.diorite_slab": "Dar diorit",
  "block.minecraft.diorite_stairs": "Diri diorit",
  "block.minecraft.diorite_wall": "Moger diorit",
  "block.minecraft.dirt": "Douar",
  "block.minecraft.dirt_path": "Hent douar",
  "block.minecraft.dispenser": "Tennerez",
  "block.minecraft.dragon_egg": "Vi aerouant",
  "block.minecraft.dragon_head": "Penn Aerouant",
  "block.minecraft.dragon_wall_head": "Penn Aerouant moger",
  "block.minecraft.dried_ghast": "Ghast disec'het",
  "block.minecraft.dried_kelp_block": "Bloc'h bezhin sec'het",
  "block.minecraft.dripstone_block": "Bloc'h hinkin-maen",
  "block.minecraft.dropper": "Ingalerez",
  "block.minecraft.emerald_block": "Bloc'h emrodez",
  "block.minecraft.emerald_ore": "Kailh emrodez",
  "block.minecraft.enchanting_table": "Taol strobinellañ",
  "block.minecraft.end_gateway": "Treuzell an End",
  "block.minecraft.end_portal": "Dor-dal an End",
  "block.minecraft.end_portal_frame": "Steuñv dor-dal an End",
  "block.minecraft.end_rod": "Bazh an End",
  "block.minecraft.end_stone": "Roc'h an End",
  "block.minecraft.end_stone_brick_slab": "Dar brikennoù roc'h an End",
  "block.minecraft.end_stone_brick_stairs": "Diri brikennoù roc'h an end",
  "block.minecraft.end_stone_brick_wall": "Moger brikennoù roc'h an End",
  "block.minecraft.end_stone_bricks": "Brikennoù roc'h an End",
  "block.minecraft.ender_chest": "Koufr an End",
  "block.minecraft.exposed_chiseled_copper": "Kouevr kizellet abimet",
  "block.minecraft.exposed_copper": "Kouevr abimet",
  "block.minecraft.exposed_copper_bars": "Barrennoù kouevr abimet",
  "block.minecraft.exposed_copper_bulb": "Kleuzeur gouevr abimet",
  "block.minecraft.exposed_copper_chain": "Chadenn gouevr abimet",
  "block.minecraft.exposed_copper_chest": "Koufr kouevr abimet",
  "block.minecraft.exposed_copper_door": "Dor gouevr abimet",
  "block.minecraft.exposed_copper_golem_statue": "Delwenn golem kouevr abimet",
  "block.minecraft.exposed_copper_grate": "Kael gouevr abimet",
  "block.minecraft.exposed_copper_lantern": "Letern kouevr abimet",
  "block.minecraft.exposed_copper_trapdoor": "Trap kouevr abimet",
  "block.minecraft.exposed_cut_copper": "Kouevr benet abimet",
  "block.minecraft.exposed_cut_copper_slab": "Dar gouevr benet abimet",
  "block.minecraft.exposed_cut_copper_stairs": "Diri kouevr benet abimet",
  "block.minecraft.exposed_lightning_rod": "Diskuruner abimet",
  "block.minecraft.farmland": "Douar troet",
  "block.minecraft.fern": "Radenenn",
  "block.minecraft.fire": "Tan",
  "block.minecraft.fire_coral": "Koural tan",
  "block.minecraft.fire_coral_block": "Bloc'h koural tan",
  "block.minecraft.fire_coral_fan": "Aveler koural tan",
  "block.minecraft.fire_coral_wall_fan": "Aveler moger koural tan",
  "block.minecraft.firefly_bush": "Bodenn preñved-lugern",
  "block.minecraft.fletching_table": "Taol gwaregañ",
  "block.minecraft.flower_pot": "Pod bleunioù",
  "block.minecraft.flowering_azalea": "Brug-roz bleuniet",
  "block.minecraft.flowering_azalea_leaves": "Delioù brug-roz bleuniet",
  "block.minecraft.frogspawn": "Vioù glesker",
  "block.minecraft.frosted_ice": "Skorn kleret",
  "block.minecraft.furnace": "Forn",
  "block.minecraft.gilded_blackstone": "Maen-du alaouret",
  "block.minecraft.glass": "Gwer",
  "block.minecraft.glass_pane": "Gwerenn",
  "block.minecraft.glow_lichen": "Liken lugernus",
  "block.minecraft.glowstone": "Maen lufrus",
  "block.minecraft.gold_block": "Bloc'h aour",
  "block.minecraft.gold_ore": "Kailh aour",
  "block.minecraft.golden_dandelion": "C'hwervizon alaouret",
  "block.minecraft.granite": "Greunit",
  "block.minecraft.granite_slab": "Dar greunit",
  "block.minecraft.granite_stairs": "Diri greunit",
  "block.minecraft.granite_wall": "Moger greunit",
  "block.minecraft.grass": "Geot",
  "block.minecraft.grass_block": "Bloc'h geot",
  "block.minecraft.gravel": "Grouan",
  "block.minecraft.gray_banner": "Banniel gris",
  "block.minecraft.gray_bed": "Gwele gris",
  "block.minecraft.gray_candle": "Boujienn c'hris",
  "block.minecraft.gray_candle_cake": "Gwastell gant ur voujienn c'hris",
  "block.minecraft.gray_carpet": "Pallenn gris",
  "block.minecraft.gray_concrete": "Betoñs gris",
  "block.minecraft.gray_concrete_powder": "Poultr betoñs gris",
  "block.minecraft.gray_glazed_terracotta": "Pri poazh amailhet gris",
  "block.minecraft.gray_shulker_box": "Boest Shulker c'hris",
  "block.minecraft.gray_stained_glass": "Gwer gris",
  "block.minecraft.gray_stained_glass_pane": "Gwerenn c'hris",
  "block.minecraft.gray_terracotta": "Pri poazh gris",
  "block.minecraft.gray_wool": "Gloan gris",
  "block.minecraft.green_banner": "Banniel gwer",
  "block.minecraft.green_bed": "Gwele gwer",
  "block.minecraft.green_candle": "Boujienn wer",
  "block.minecraft.green_candle_cake": "Gwastell gant ur voujienn wer",
  "block.minecraft.green_carpet": "Pallenn gwer",
  "block.minecraft.green_concrete": "Betoñs gwer",
  "block.minecraft.green_concrete_powder": "Poultr betoñs gwer",
  "block.minecraft.green_glazed_terracotta": "Pri poazh amailhet gwer",
  "block.minecraft.green_shulker_box": "Boest Shulker wer",
  "block.minecraft.green_stained_glass": "Gwer gwer",
  "block.minecraft.green_stained_glass_pane": "Gwerenn wer",
  "block.minecraft.green_terracotta": "Pri poazh gwer",
  "block.minecraft.green_wool": "Gloan gwer",
  "block.minecraft.grindstone": "Breolim",
  "block.minecraft.hanging_roots": "Gwrizioù a-ispilh",
  "block.minecraft.hay_block": "Boutellenn blouz",
  "block.minecraft.heavy_core": "Derc'han pounner",
  "block.minecraft.heavy_weighted_pressure_plate": "Plakenn wask pounner pouezet",
  "block.minecraft.honey_block": "Bloc'h mel",
  "block.minecraft.honeycomb_block": "Bloc'h follenn goar",
  "block.minecraft.hopper": "Founilh",
  "block.minecraft.horn_coral": "Koural kerniel",
  "block.minecraft.horn_coral_block": "Bloc'h koural kerniel",
  "block.minecraft.horn_coral_fan": "Aveler koural kerniel",
  "block.minecraft.horn_coral_wall_fan": "Aveler moger koural kerniel",
  "block.minecraft.ice": "Skorn",
  "block.minecraft.infested_chiseled_stone_bricks": "Brikennoù roc'h kizellet kontronet",
  "block.minecraft.infested_cobblestone": "Maen kontronet",
  "block.minecraft.infested_cracked_stone_bricks": "Brikennoù roc'h faotet kontronet",
  "block.minecraft.infested_deepslate": "Maen-glas an isfont kontronet",
  "block.minecraft.infested_mossy_stone_bricks": "Brikennoù roc'h manek kontronet",
  "block.minecraft.infested_stone": "Roc'h kontronet",
  "block.minecraft.infested_stone_bricks": "Brikennoù roc'h kontronet",
  "block.minecraft.iron_bars": "Barrennoù houarn",
  "block.minecraft.iron_block": "Bloc'h houarn",
  "block.minecraft.iron_chain": "Chadenn houarn",
  "block.minecraft.iron_door": "Dor houarn",
  "block.minecraft.iron_ore": "Kailh houarn",
  "block.minecraft.iron_trapdoor": "Trap houarn",
  "block.minecraft.jack_o_lantern": "Sitrouilhezenn-letern",
  "block.minecraft.jigsaw": "Bloc'h miltamm",
  "block.minecraft.jukebox": "Jukebox",
  "block.minecraft.jungle_button": "Bouton koad janglenn",
  "block.minecraft.jungle_door": "Dor koad janglenn",
  "block.minecraft.jungle_fence": "Kloued koad janglenn",
  "block.minecraft.jungle_fence_gate": "Dorikell koad janglenn",
  "block.minecraft.jungle_hanging_sign": "Panell koad janglenn a-ispilh",
  "block.minecraft.jungle_leaves": "Delioù janglenn",
  "block.minecraft.jungle_log": "Etev koad janglenn",
  "block.minecraft.jungle_planks": "Plankennoù koad janglenn",
  "block.minecraft.jungle_pressure_plate": "Plakenn wask koad janglenn",
  "block.minecraft.jungle_sapling": "Strujenn janglenn",
  "block.minecraft.jungle_shelf": "Stalenn koad janglenn",
  "block.minecraft.jungle_sign": "Panell koad janglenn",
  "block.minecraft.jungle_slab": "Dar koad janglenn",
  "block.minecraft.jungle_stairs": "Diri koad janglenn",
  "block.minecraft.jungle_trapdoor": "Trap koad janglenn",
  "block.minecraft.jungle_wall_hanging_sign": "Panell-voger koad janglenn a-ispilh",
  "block.minecraft.jungle_wall_sign": "Panell-voger koad janglenn",
  "block.minecraft.jungle_wood": "Koad janglenn",
  "block.minecraft.kelp": "Bezhin",
  "block.minecraft.kelp_plant": "Plantenn vezhin",
  "block.minecraft.ladder": "Skeul",
  "block.minecraft.lantern": "Letern",
  "block.minecraft.lapis_block": "Bloc'h Lapis Lazuli",
  "block.minecraft.lapis_ore": "Kailh Lapis Lazuli",
  "block.minecraft.large_amethyst_bud": "Broñsenn ametist vras",
  "block.minecraft.large_fern": "Radenenn vras",
  "block.minecraft.lava": "Lava",
  "block.minecraft.lava_cauldron": "Kaoter lava",
  "block.minecraft.leaf_litter": "Delioù sec'h",
  "block.minecraft.lectern": "Letrin",
  "block.minecraft.lever": "Loc'henn",
  "block.minecraft.light": "Gouloù",
  "block.minecraft.light_blue_banner": "Banniel glas sklaer",
  "block.minecraft.light_blue_bed": "Gwele glas sklaer",
  "block.minecraft.light_blue_candle": "Boujienn c'hlas sklaer",
  "block.minecraft.light_blue_candle_cake": "Gwastell gant ur voujienn c'hlas sklaer",
  "block.minecraft.light_blue_carpet": "Pallenn glas sklaer",
  "block.minecraft.light_blue_concrete": "Betoñs glas sklaer",
  "block.minecraft.light_blue_concrete_powder": "Poultr betoñs sian",
  "block.minecraft.light_blue_glazed_terracotta": "Pri poazh amailhet glas sklaer",
  "block.minecraft.light_blue_shulker_box": "Boest Shulker c'hlas sklaer",
  "block.minecraft.light_blue_stained_glass": "Gwer glas sklaer",
  "block.minecraft.light_blue_stained_glass_pane": "Gwerenn c'hlas sklaer",
  "block.minecraft.light_blue_terracotta": "Pri poazh glas sklaer",
  "block.minecraft.light_blue_wool": "Gloan glas sklaer",
  "block.minecraft.light_gray_banner": "Banniel gris sklaer",
  "block.minecraft.light_gray_bed": "Gwele gris sklaer",
  "block.minecraft.light_gray_candle": "Boujienn c'hris sklaer",
  "block.minecraft.light_gray_candle_cake": "Gwastell gant ur voujienn c'hris sklaer",
  "block.minecraft.light_gray_carpet": "Pallenn gris sklaer",
  "block.minecraft.light_gray_concrete": "Betoñs gris sklaer",
  "block.minecraft.light_gray_concrete_powder": "Poultr betoñs gris sklaer",
  "block.minecraft.light_gray_glazed_terracotta": "Pri poazh amailhet gris sklaer",
  "block.minecraft.light_gray_shulker_box": "Boest Shulker c'hris sklaer",
  "block.minecraft.light_gray_stained_glass": "Gwer gris sklaer",
  "block.minecraft.light_gray_stained_glass_pane": "Gwerenn c'hris sklaer",
  "block.minecraft.light_gray_terracotta": "Pri poazh gris sklaer",
  "block.minecraft.light_gray_wool": "Gloan gris sklaer",
  "block.minecraft.light_weighted_pressure_plate": "Plakenn wask skañv pouezet",
  "block.minecraft.lightning_rod": "Diskuruner",
  "block.minecraft.lilac": "Lireu",
  "block.minecraft.lily_of_the_valley": "Louzaouenn-an-hañv",
  "block.minecraft.lily_pad": "Loa-zour",
  "block.minecraft.lime_banner": "Banniel gwer-melen",
  "block.minecraft.lime_bed": "Gwele gwer-melen",
  "block.minecraft.lime_candle": "Boujienn wer sklaer",
  "block.minecraft.lime_candle_cake": "Gwastell gant ur voujienn wer sklaer",
  "block.minecraft.lime_carpet": "Pallenn gwer-melen",
  "block.minecraft.lime_concrete": "Betoñs gwer-melen",
  "block.minecraft.lime_concrete_powder": "Poultr betoñs gwer-melen",
  "block.minecraft.lime_glazed_terracotta": "Pri poazh amailhet gwer-melen",
  "block.minecraft.lime_shulker_box": "Boest Shulker wer sklaer",
  "block.minecraft.lime_stained_glass": "Gwer gwer sklaer",
  "block.minecraft.lime_stained_glass_pane": "Gwerenn wer sklaer",
  "block.minecraft.lime_terracotta": "Pri poazh gwer-melen",
  "block.minecraft.lime_wool": "Gloan gwer-melen",
  "block.minecraft.lodestone": "Maen-touch",
  "block.minecraft.loom": "Stern-gwiader",
  "block.minecraft.magenta_banner": "Banniel limestra",
  "block.minecraft.magenta_bed": "Gwele limestra",
  "block.minecraft.magenta_candle": "Boujienn limestra",
  "block.minecraft.magenta_candle_cake": "Gwastell gant ur voujienn limestra",
  "block.minecraft.magenta_carpet": "Pallenn majenta",
  "block.minecraft.magenta_concrete": "Betoñs limestra",
  "block.minecraft.magenta_concrete_powder": "Poultr betoñs limestra",
  "block.minecraft.magenta_glazed_terracotta": "Pri poazh amailhet limestra",
  "block.minecraft.magenta_shulker_box": "Boest Shulker limestra",
  "block.minecraft.magenta_stained_glass": "Gwer limestra",
  "block.minecraft.magenta_stained_glass_pane": "Gwerenn limestra",
  "block.minecraft.magenta_terracotta": "Pri poazh limestra",
  "block.minecraft.magenta_wool": "Gloan majenta",
  "block.minecraft.magma_block": "Bloc'h magma",
  "block.minecraft.mangrove_button": "Bouton manglez",
  "block.minecraft.mangrove_door": "Dor vanglez",
  "block.minecraft.mangrove_fence": "Kloued vanglez",
  "block.minecraft.mangrove_fence_gate": "Dorikell vanglez",
  "block.minecraft.mangrove_hanging_sign": "Panell vanglez a-ispilh",
  "block.minecraft.mangrove_leaves": "Delioù manglez",
  "block.minecraft.mangrove_log": "Kef manglez",
  "block.minecraft.mangrove_planks": "Plankennoù manglez",
  "block.minecraft.mangrove_pressure_plate": "Plakenn wask manglez",
  "block.minecraft.mangrove_propagule": "Propagul manglez",
  "block.minecraft.mangrove_roots": "Gwrizioù manglez",
  "block.minecraft.mangrove_shelf": "Stalenn vanglez",
  "block.minecraft.mangrove_sign": "Panell vanglez",
  "block.minecraft.mangrove_slab": "Dar manglez",
  "block.minecraft.mangrove_stairs": "Diri manglez",
  "block.minecraft.mangrove_trapdoor": "Trap manglez",
  "block.minecraft.mangrove_wall_hanging_sign": "Panell-voger vanglez a-ispilh",
  "block.minecraft.mangrove_wall_sign": "Panell voger manglez",
  "block.minecraft.mangrove_wood": "Koad manglez",
  "block.minecraft.medium_amethyst_bud": "Broñsenn ametist etre",
  "block.minecraft.melon": "Sukrinenn",
  "block.minecraft.melon_stem": "Garenn sukrinenn",
  "block.minecraft.moss_block": "Bloc'h man",
  "block.minecraft.moss_carpet": "Pallenn man",
  "block.minecraft.mossy_cobblestone": "Maen manek",
  "block.minecraft.mossy_cobblestone_slab": "Dar maen manek",
  "block.minecraft.mossy_cobblestone_stairs": "Diri maen manek",
  "block.minecraft.mossy_cobblestone_wall": "Moger maen manek",
  "block.minecraft.mossy_stone_brick_slab": "Dar brikennoù roc'h manek",
  "block.minecraft.mossy_stone_brick_stairs": "Diri brikennoù roc'h manek",
  "block.minecraft.mossy_stone_brick_wall": "Moger brikennoù roc'h manek",
  "block.minecraft.mossy_stone_bricks": "Brikennoù roc'h manek",
  "block.minecraft.moving_piston": "Bountell fiñv",
  "block.minecraft.mud": "Fank",
  "block.minecraft.mud_brick_slab": "Dar brikennoù fank",
  "block.minecraft.mud_brick_stairs": "Diri brikennoù fank",
  "block.minecraft.mud_brick_wall": "Moger brikennoù fank",
  "block.minecraft.mud_bricks": "Brikennoù fank",
  "block.minecraft.muddy_mangrove_roots": "Gwrizioù manglez fankek",
  "block.minecraft.mushroom_stem": "Troad kabell-touseg",
  "block.minecraft.mycelium": "Mikeliom",
  "block.minecraft.nether_brick_fence": "Kloued brikennoù an Nether",
  "block.minecraft.nether_brick_slab": "Dar brikennoù an Nether",
  "block.minecraft.nether_brick_stairs": "Diri brikennoù an Nether",
  "block.minecraft.nether_brick_wall": "Moger brikennoù an Nether",
  "block.minecraft.nether_bricks": "Brikennoù an Nether",
  "block.minecraft.nether_gold_ore": "Kailh aour an Nether",
  "block.minecraft.nether_portal": "Dor-dal an Nether",
  "block.minecraft.nether_quartz_ore": "Kailh kouarz an Nether",
  "block.minecraft.nether_sprouts": "Kellid an Nether",
  "block.minecraft.nether_wart": "Gwenaenn an Nether",
  "block.minecraft.nether_wart_block": "Bloc'h gwenaennoù an Nether",
  "block.minecraft.netherite_block": "Bloc'h Netherite",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Bloc'h notenn",
  "block.minecraft.oak_button": "Bouton derv",
  "block.minecraft.oak_door": "Dor zerv",
  "block.minecraft.oak_fence": "Kloued derv",
  "block.minecraft.oak_fence_gate": "Dorikell derv",
  "block.minecraft.oak_hanging_sign": "Panell derv a-ispilh",
  "block.minecraft.oak_leaves": "Delioù derv",
  "block.minecraft.oak_log": "Etev derv",
  "block.minecraft.oak_planks": "Plankennoù derv",
  "block.minecraft.oak_pressure_plate": "Plakenn wask derv",
  "block.minecraft.oak_sapling": "Strujenn zerv",
  "block.minecraft.oak_shelf": "Stalenn derv",
  "block.minecraft.oak_sign": "Panell derv",
  "block.minecraft.oak_slab": "Dar derv",
  "block.minecraft.oak_stairs": "Diri derv",
  "block.minecraft.oak_trapdoor": "Trap derv",
  "block.minecraft.oak_wall_hanging_sign": "Panell-voger derv a-ispilh",
  "block.minecraft.oak_wall_sign": "Panell-voger derv",
  "block.minecraft.oak_wood": "Koad derv",
  "block.minecraft.observer": "Arvester",
  "block.minecraft.obsidian": "Obsidian",
  "block.minecraft.ochre_froglight": "Tousegouloù melendu",
  "block.minecraft.ominous_banner": "Banniel gourdrouzus",
  "block.minecraft.open_eyeblossom": "Bleunienn-lagad digor",
  "block.minecraft.orange_banner": "Banniel orañjez",
  "block.minecraft.orange_bed": "Gwele orañjez",
  "block.minecraft.orange_candle": "Boujienn orañjez",
  "block.minecraft.orange_candle_cake": "Gwastell gant ur voujienn orañjez",
  "block.minecraft.orange_carpet": "Pallenn orañjez",
  "block.minecraft.orange_concrete": "Betoñs orañjez",
  "block.minecraft.orange_concrete_powder": "Poultr betoñs orañjez",
  "block.minecraft.orange_glazed_terracotta": "Pri poazh amailhet orañjez",
  "block.minecraft.orange_shulker_box": "Boest Shulker orañjez",
  "block.minecraft.orange_stained_glass": "Gwer orañjez",
  "block.minecraft.orange_stained_glass_pane": "Gwerenn orañjez",
  "block.minecraft.orange_terracotta": "Pri poazh orañjez",
  "block.minecraft.orange_tulip": "Tulipezenn orañjez",
  "block.minecraft.orange_wool": "Gloan orañjez",
  "block.minecraft.oxeye_daisy": "Marc'harid",
  "block.minecraft.oxidized_chiseled_copper": "Kouevr kizellet merglet",
  "block.minecraft.oxidized_copper": "Kouevr merglet",
  "block.minecraft.oxidized_copper_bars": "Barrennoù kouevr merglet",
  "block.minecraft.oxidized_copper_bulb": "Kleuzeur gouevr merglet",
  "block.minecraft.oxidized_copper_chain": "Chadenn gouevr merglet",
  "block.minecraft.oxidized_copper_chest": "Koufr kouevr merglet",
  "block.minecraft.oxidized_copper_door": "Dor gouevr merglet",
  "block.minecraft.oxidized_copper_golem_statue": "Delwenn golem kouevr merglet",
  "block.minecraft.oxidized_copper_grate": "Kael gouevr merglet",
  "block.minecraft.oxidized_copper_lantern": "Letern kouevr merglet",
  "block.minecraft.oxidized_copper_trapdoor": "Trap kouevr merglet",
  "block.minecraft.oxidized_cut_copper": "Kouevr benet merglet",
  "block.minecraft.oxidized_cut_copper_slab": "Dar gouevr benet merglet",
  "block.minecraft.oxidized_cut_copper_stairs": "Diri kouevr benet merglet",
  "block.minecraft.oxidized_lightning_rod": "Diskuruner merglet",
  "block.minecraft.packed_ice": "Skorn fetis",
  "block.minecraft.packed_mud": "Pri-plouz",
  "block.minecraft.pale_hanging_moss": "Man disliv a-ispilh",
  "block.minecraft.pale_moss_block": "Bloc'h man disliv",
  "block.minecraft.pale_moss_carpet": "Pallenn man disliv",
  "block.minecraft.pale_oak_button": "Bouton derv disliv",
  "block.minecraft.pale_oak_door": "Dor derv disliv",
  "block.minecraft.pale_oak_fence": "Kloued derv disliv",
  "block.minecraft.pale_oak_fence_gate": "Dorikell derv disliv",
  "block.minecraft.pale_oak_hanging_sign": "Panell derv disliv a-ispilh",
  "block.minecraft.pale_oak_leaves": "Delioù derv disliv",
  "block.minecraft.pale_oak_log": "Etev derv disliv",
  "block.minecraft.pale_oak_planks": "Plankennoù derv disliv",
  "block.minecraft.pale_oak_pressure_plate": "Plakenn-wask derv disliv",
  "block.minecraft.pale_oak_sapling": "Strujenn derv disliv",
  "block.minecraft.pale_oak_shelf": "Stalenn derv disliv",
  "block.minecraft.pale_oak_sign": "Panell derv disliv",
  "block.minecraft.pale_oak_slab": "Dar derv disliv",
  "block.minecraft.pale_oak_stairs": "Diri derv disliv",
  "block.minecraft.pale_oak_trapdoor": "Trap derv disliv",
  "block.minecraft.pale_oak_wall_hanging_sign": "Panell derv disliv a-ispilh",
  "block.minecraft.pale_oak_wall_sign": "Panell-voger derv disliv",
  "block.minecraft.pale_oak_wood": "Koad derv disliv",
  "block.minecraft.pearlescent_froglight": "Tousegouloù perlezet",
  "block.minecraft.peony": "Pivoena",
  "block.minecraft.petrified_oak_slab": "Dar derv maenaet",
  "block.minecraft.piglin_head": "Penn piglin",
  "block.minecraft.piglin_wall_head": "Penn piglin moger",
  "block.minecraft.pink_banner": "Banniel roz",
  "block.minecraft.pink_bed": "Gwele roz",
  "block.minecraft.pink_candle": "Boujienn roz",
  "block.minecraft.pink_candle_cake": "Gwastell gant ur voujienn roz",
  "block.minecraft.pink_carpet": "Pallenn roz",
  "block.minecraft.pink_concrete": "Betoñs roz",
  "block.minecraft.pink_concrete_powder": "Poultr betoñs roz",
  "block.minecraft.pink_glazed_terracotta": "Pri poazh amailhet roz",
  "block.minecraft.pink_petals": "Petalennoù roz",
  "block.minecraft.pink_shulker_box": "Boest Shulker roz",
  "block.minecraft.pink_stained_glass": "Gwer roz",
  "block.minecraft.pink_stained_glass_pane": "Gwerenn roz",
  "block.minecraft.pink_terracotta": "Pri poazh roz",
  "block.minecraft.pink_tulip": "Tulipezenn roz",
  "block.minecraft.pink_wool": "Gloan roz",
  "block.minecraft.piston": "Bountell",
  "block.minecraft.piston_head": "Penn bountell",
  "block.minecraft.pitcher_crop": "Strujenn jarlili",
  "block.minecraft.pitcher_plant": "Jarlili",
  "block.minecraft.player_head": "Penn c'hoarier",
  "block.minecraft.player_head.named": "Penn %s",
  "block.minecraft.player_wall_head": "Penn c'hoarier moger",
  "block.minecraft.podzol": "Podzol",
  "block.minecraft.pointed_dripstone": "Hinkin-maen begek",
  "block.minecraft.polished_andesite": "Andezit lufret",
  "block.minecraft.polished_andesite_slab": "Dar andezit lintr",
  "block.minecraft.polished_andesite_stairs": "Diri andezit lintr",
  "block.minecraft.polished_basalt": "Bazalt lufret",
  "block.minecraft.polished_blackstone": "Maen-du lintr",
  "block.minecraft.polished_blackstone_brick_slab": "Dar brikennoù maen-du lintr",
  "block.minecraft.polished_blackstone_brick_stairs": "Diri brikennoù maen-du lintr",
  "block.minecraft.polished_blackstone_brick_wall": "Moger brikennoù maen-du lintr",
  "block.minecraft.polished_blackstone_bricks": "Brikennoù maen-du lintr",
  "block.minecraft.polished_blackstone_button": "Bouton maen-du lintr",
  "block.minecraft.polished_blackstone_pressure_plate": "Plakenn wask maen-du lufret",
  "block.minecraft.polished_blackstone_slab": "Dar vaen-du lintr",
  "block.minecraft.polished_blackstone_stairs": "Diri maen-du lufret",
  "block.minecraft.polished_blackstone_wall": "Moger maen-du lintr",
  "block.minecraft.polished_deepslate": "Maen-glas an isfont lintr",
  "block.minecraft.polished_deepslate_slab": "Dar maen-glas an isfont lintr",
  "block.minecraft.polished_deepslate_stairs": "Diri maen-glas an isfont lintr",
  "block.minecraft.polished_deepslate_wall": "Moger maen-glas an isfont lintr",
  "block.minecraft.polished_diorite": "Diorit lufret",
  "block.minecraft.polished_diorite_slab": "Dar diorit lintr",
  "block.minecraft.polished_diorite_stairs": "Diri diorit lintr",
  "block.minecraft.polished_granite": "Greunit lufret",
  "block.minecraft.polished_granite_slab": "Dar greunit lintr",
  "block.minecraft.polished_granite_stairs": "Diri greunit lintr",
  "block.minecraft.polished_tuff": "Tuf lintr",
  "block.minecraft.polished_tuff_slab": "Dar tuf lintr",
  "block.minecraft.polished_tuff_stairs": "Diri tuf lintr",
  "block.minecraft.polished_tuff_wall": "Moger tuf lintr",
  "block.minecraft.poppy": "Rozenn-moc'h",
  "block.minecraft.potatoes": "Avaloù-douar",
  "block.minecraft.potted_acacia_sapling": "Podad strujenn gasia",
  "block.minecraft.potted_allium": "Podad allium",
  "block.minecraft.potted_azalea_bush": "Podad brug-roz",
  "block.minecraft.potted_azure_bluet": "Podad houstonia",
  "block.minecraft.potted_bamboo": "Podad bambouz",
  "block.minecraft.potted_birch_sapling": "Podad strujenn vezv",
  "block.minecraft.potted_blue_orchid": "Podad orkideenn c'hlas",
  "block.minecraft.potted_brown_mushroom": "Podad kabell-touseg gell",
  "block.minecraft.potted_cactus": "Podad kaktuz",
  "block.minecraft.potted_cherry_sapling": "Podad strujenn wez-kerez",
  "block.minecraft.potted_closed_eyeblossom": "Podad bleunienn-lagad serr",
  "block.minecraft.potted_cornflower": "Podad glizinenn",
  "block.minecraft.potted_crimson_fungus": "Podad kabell-touseg ruz-tane",
  "block.minecraft.potted_crimson_roots": "Podad gwrizioù ruz-tane",
  "block.minecraft.potted_dandelion": "Podad c'hwervizon",
  "block.minecraft.potted_dark_oak_sapling": "Podad strujenn derv teñval",
  "block.minecraft.potted_dead_bush": "Podad bod marv",
  "block.minecraft.potted_fern": "Podad radenenn",
  "block.minecraft.potted_flowering_azalea_bush": "Podad brug-roz bleuniet",
  "block.minecraft.potted_golden_dandelion": "Podad c'hwervizon alaouret",
  "block.minecraft.potted_jungle_sapling": "Podad strujenn wez-janglenn",
  "block.minecraft.potted_lily_of_the_valley": "Podad louzaouenn-an-hañv",
  "block.minecraft.potted_mangrove_propagule": "Podad propagul manglez",
  "block.minecraft.potted_oak_sapling": "Podad strujenn derv",
  "block.minecraft.potted_open_eyeblossom": "Podad bleunienn-lagad digor",
  "block.minecraft.potted_orange_tulip": "Podad tulipezenn orañjez",
  "block.minecraft.potted_oxeye_daisy": "Podad marc'harid",
  "block.minecraft.potted_pale_oak_sapling": "Podad strujenn derv disliv",
  "block.minecraft.potted_pink_tulip": "Podad tulipezenn roz",
  "block.minecraft.potted_poppy": "Podad rozenn-moc'h",
  "block.minecraft.potted_red_mushroom": "Podad kabell-touseg ruz",
  "block.minecraft.potted_red_tulip": "Podad tulipezenn ruz",
  "block.minecraft.potted_spruce_sapling": "Podad strujenn bruñs",
  "block.minecraft.potted_torchflower": "Podad bleunienn-flamm",
  "block.minecraft.potted_warped_fungus": "Podad kabell-touseg disleber",
  "block.minecraft.potted_warped_roots": "Podad gwrizioù disleber",
  "block.minecraft.potted_white_tulip": "Podad tulipezenn wenn",
  "block.minecraft.potted_wither_rose": "Podad rozenn Wither",
  "block.minecraft.powder_snow": "Erc'h poultrek",
  "block.minecraft.powder_snow_cauldron": "Kaoter erc'h poultrek",
  "block.minecraft.powered_rail": "Hent-houarn galloudus",
  "block.minecraft.prismarine": "Prismarine",
  "block.minecraft.prismarine_brick_slab": "Dar brikennoù prismarine",
  "block.minecraft.prismarine_brick_stairs": "Diri brikennoù prismarine",
  "block.minecraft.prismarine_bricks": "Brikennoù prismarine",
  "block.minecraft.prismarine_slab": "Dar prismarine",
  "block.minecraft.prismarine_stairs": "Diri prismarine",
  "block.minecraft.prismarine_wall": "Moger prismarine",
  "block.minecraft.pumpkin": "Sitrouilhezenn",
  "block.minecraft.pumpkin_stem": "Garenn sitrouilhezenn",
  "block.minecraft.purple_banner": "Banniel mouk",
  "block.minecraft.purple_bed": "Gwele mouk",
  "block.minecraft.purple_candle": "Boujienn vouk",
  "block.minecraft.purple_candle_cake": "Gwastell gant ur voujienn vouk",
  "block.minecraft.purple_carpet": "Pallenn mouk",
  "block.minecraft.purple_concrete": "Betoñs mouk",
  "block.minecraft.purple_concrete_powder": "Poultr betoñs mouk",
  "block.minecraft.purple_glazed_terracotta": "Pri poazh amailhet mouk",
  "block.minecraft.purple_shulker_box": "Boest Shulker mouk",
  "block.minecraft.purple_stained_glass": "Gwer mouk",
  "block.minecraft.purple_stained_glass_pane": "Gwerenn vouk",
  "block.minecraft.purple_terracotta": "Pri poazh mouk",
  "block.minecraft.purple_wool": "Gloan mouk",
  "block.minecraft.purpur_block": "Bloc'h purpur",
  "block.minecraft.purpur_pillar": "Peul purpur",
  "block.minecraft.purpur_slab": "Dar purpur",
  "block.minecraft.purpur_stairs": "Diri purpur",
  "block.minecraft.quartz_block": "Bloc'h kouarz",
  "block.minecraft.quartz_bricks": "Brikennoù kouarz",
  "block.minecraft.quartz_pillar": "Peul kouarz",
  "block.minecraft.quartz_slab": "Dar kouarz",
  "block.minecraft.quartz_stairs": "Diri kouarz",
  "block.minecraft.rail": "Hent-houarn",
  "block.minecraft.raw_copper_block": "Bloc'h kouevr kriz",
  "block.minecraft.raw_gold_block": "Bloc'h aour kriz",
  "block.minecraft.raw_iron_block": "Bloc'h houarn kriz",
  "block.minecraft.red_banner": "Banniel ruz",
  "block.minecraft.red_bed": "Gwele ruz",
  "block.minecraft.red_candle": "Boujienn ruz",
  "block.minecraft.red_candle_cake": "Gwastell gant ur voujienn ruz",
  "block.minecraft.red_carpet": "Pallenn ruz",
  "block.minecraft.red_concrete": "Betoñs ruz",
  "block.minecraft.red_concrete_powder": "Poultr betoñs ruz",
  "block.minecraft.red_glazed_terracotta": "Pri poazh amailhet ruz",
  "block.minecraft.red_mushroom": "Kabell-touseg ruz",
  "block.minecraft.red_mushroom_block": "Bloc'h kabell-touseg ruz",
  "block.minecraft.red_nether_brick_slab": "Dar brikennoù ruz an Nether",
  "block.minecraft.red_nether_brick_stairs": "Diri brikennoù ruz an Nether",
  "block.minecraft.red_nether_brick_wall": "Moger brikennoù ruz an Nether",
  "block.minecraft.red_nether_bricks": "Brikennoù ruz an Nether",
  "block.minecraft.red_sand": "Traezh ruz",
  "block.minecraft.red_sandstone": "Maen-krag ruz",
  "block.minecraft.red_sandstone_slab": "Dar vaen-krag ruz",
  "block.minecraft.red_sandstone_stairs": "Diri maen-krag ruz",
  "block.minecraft.red_sandstone_wall": "Moger vaen-krag ruz",
  "block.minecraft.red_shulker_box": "Boest Shulker ruz",
  "block.minecraft.red_stained_glass": "Gwer ruz",
  "block.minecraft.red_stained_glass_pane": "Gwerenn ruz",
  "block.minecraft.red_terracotta": "Pri poazh ruz",
  "block.minecraft.red_tulip": "Tulipezenn ruz",
  "block.minecraft.red_wool": "Gloan ruz",
  "block.minecraft.redstone_block": "Bloc'h Redstone",
  "block.minecraft.redstone_lamp": "Gouloù Redstone",
  "block.minecraft.redstone_ore": "Kailh Redstone",
  "block.minecraft.redstone_torch": "Etev-gouloù Redstone",
  "block.minecraft.redstone_wall_torch": "Etev-gouloù moger redstone",
  "block.minecraft.redstone_wire": "Orjalenn Redstone",
  "block.minecraft.reinforced_deepslate": "Maen-glas an isfont kreñvaet",
  "block.minecraft.repeater": "Adkaser Redstone",
  "block.minecraft.repeating_command_block": "Bloc'h adurzhiañ",
  "block.minecraft.resin_block": "Bloc'h rousin",
  "block.minecraft.resin_brick_slab": "Dar brikennoù rousin",
  "block.minecraft.resin_brick_stairs": "Diri brikennoù rousin",
  "block.minecraft.resin_brick_wall": "Moger brikennoù rousin",
  "block.minecraft.resin_bricks": "Brikennoù rousin",
  "block.minecraft.resin_clump": "Bern rousin",
  "block.minecraft.respawn_anchor": "Eor dasorc'hiñ",
  "block.minecraft.rooted_dirt": "Douar gwriziennek",
  "block.minecraft.rose_bush": "Bod-roz",
  "block.minecraft.sand": "Traezh",
  "block.minecraft.sandstone": "Maen-krag",
  "block.minecraft.sandstone_slab": "Dar vaen-krag",
  "block.minecraft.sandstone_stairs": "Diri maen-krag",
  "block.minecraft.sandstone_wall": "Moger vaen-krag",
  "block.minecraft.scaffolding": "Chafod",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Katalizer Sculk",
  "block.minecraft.sculk_sensor": "Diguzher Sculk",
  "block.minecraft.sculk_shrieker": "Skrijer Sculk",
  "block.minecraft.sculk_vein": "Gwazhienn Sculk",
  "block.minecraft.sea_lantern": "Letern mor",
  "block.minecraft.sea_pickle": "Gwerc'heot",
  "block.minecraft.seagrass": "Geot mor",
  "block.minecraft.set_spawn": "Lec'h dasorc'hiñ spisaet",
  "block.minecraft.short_dry_grass": "Geot sec'h bihan",
  "block.minecraft.short_grass": "Geot bihan",
  "block.minecraft.shroomlight": "Gouloù-foue",
  "block.minecraft.shulker_box": "Boest Shulker",
  "block.minecraft.skeleton_skull": "Klopenn",
  "block.minecraft.skeleton_wall_skull": "Klopenn moger",
  "block.minecraft.slime_block": "Bloc'h slime",
  "block.minecraft.small_amethyst_bud": "Broñsenn ametist vihan",
  "block.minecraft.small_dripleaf": "Dourzelienn vihan",
  "block.minecraft.smithing_table": "Taol c'hoveliañ",
  "block.minecraft.smoker": "Mogedlec'h",
  "block.minecraft.smooth_basalt": "Bazalt lintr",
  "block.minecraft.smooth_quartz": "Bloc'h kouarz plaen",
  "block.minecraft.smooth_quartz_slab": "Dar kouarz lintr",
  "block.minecraft.smooth_quartz_stairs": "Diri kouarz lintr",
  "block.minecraft.smooth_red_sandstone": "Maen-krag ruz lintr",
  "block.minecraft.smooth_red_sandstone_slab": "Dar vaen-krag ruz lintr",
  "block.minecraft.smooth_red_sandstone_stairs": "Diri maen-krag ruz lintr",
  "block.minecraft.smooth_sandstone": "Maen-krag lintr",
  "block.minecraft.smooth_sandstone_slab": "Dar vaen-krag lintr",
  "block.minecraft.smooth_sandstone_stairs": "Diri maen-krag lintr",
  "block.minecraft.smooth_stone": "Roc'h plaen",
  "block.minecraft.smooth_stone_slab": "Dar roc'h plaen",
  "block.minecraft.sniffer_egg": "Vi rufler",
  "block.minecraft.snow": "Erc'h",
  "block.minecraft.snow_block": "Bloc'h erc'h",
  "block.minecraft.soul_campfire": "Tan-kamp an eneoù",
  "block.minecraft.soul_fire": "Tan an eneoù",
  "block.minecraft.soul_lantern": "Letern an eneoù",
  "block.minecraft.soul_sand": "Traezh an eneoù",
  "block.minecraft.soul_soil": "Douar an eneoù",
  "block.minecraft.soul_torch": "Etev-gouloù an eneoù",
  "block.minecraft.soul_wall_torch": "Etev-gouloù moger an eneoù",
  "block.minecraft.spawn.not_valid": "N'ho peus na gwele nag eor dasorc'hiñ karget, pe strobet eo bet",
  "block.minecraft.spawner": "Ganerez euzhviled",
  "block.minecraft.spawner.desc1": "Ober gant ur vi genel:",
  "block.minecraft.spawner.desc2": "A dermen ar seurt krouadur",
  "block.minecraft.sponge": "Spoueenn",
  "block.minecraft.spore_blossom": "Bleunienn spor",
  "block.minecraft.spruce_button": "Bouton sapr",
  "block.minecraft.spruce_door": "Dor bruñs",
  "block.minecraft.spruce_fence": "Kloued pruñs",
  "block.minecraft.spruce_fence_gate": "Dorikell pruñs",
  "block.minecraft.spruce_hanging_sign": "Panell pruñs a-ispilh",
  "block.minecraft.spruce_leaves": "Delioù pruñs",
  "block.minecraft.spruce_log": "Etev pruñs",
  "block.minecraft.spruce_planks": "Plankennoù pruñs",
  "block.minecraft.spruce_pressure_plate": "Plakenn wask pruñs",
  "block.minecraft.spruce_sapling": "Strujenn bruñs",
  "block.minecraft.spruce_shelf": "Stalenn sapr",
  "block.minecraft.spruce_sign": "Panell bruñs",
  "block.minecraft.spruce_slab": "Dar pruñs",
  "block.minecraft.spruce_stairs": "Diri pruñs",
  "block.minecraft.spruce_trapdoor": "Trap bruñs",
  "block.minecraft.spruce_wall_hanging_sign": "Panell-voger pruñs a-ispilh",
  "block.minecraft.spruce_wall_sign": "Panell voger pruñs",
  "block.minecraft.spruce_wood": "Koad pruñs",
  "block.minecraft.sticky_piston": "Bountell begus",
  "block.minecraft.stone": "Roc'h",
  "block.minecraft.stone_brick_slab": "Dar brikennoù roc'h",
  "block.minecraft.stone_brick_stairs": "Diri brikennoù roc'h",
  "block.minecraft.stone_brick_wall": "Moger brikennoù roc'h",
  "block.minecraft.stone_bricks": "Brikennoù roc'h",
  "block.minecraft.stone_button": "Bouton maen",
  "block.minecraft.stone_pressure_plate": "Plakenn wask maen",
  "block.minecraft.stone_slab": "Dar roc'h",
  "block.minecraft.stone_stairs": "Diri roc'h",
  "block.minecraft.stonecutter": "Bener-mein",
  "block.minecraft.stripped_acacia_log": "Etev kasia dirusket",
  "block.minecraft.stripped_acacia_wood": "Koad kasia dirusket",
  "block.minecraft.stripped_bamboo_block": "Bloc'h bambouz dirusket",
  "block.minecraft.stripped_birch_log": "Etev bezv dirusket",
  "block.minecraft.stripped_birch_wood": "Koad bezv dirusket",
  "block.minecraft.stripped_cherry_log": "Etev koad-kerez dirusket",
  "block.minecraft.stripped_cherry_wood": "Koad-kerez dirusket",
  "block.minecraft.stripped_crimson_hyphae": "Hifennoù ruz-tane dirusket",
  "block.minecraft.stripped_crimson_stem": "Korzenn ruz-tane dirusket",
  "block.minecraft.stripped_dark_oak_log": "Etev derv teñval dirusket",
  "block.minecraft.stripped_dark_oak_wood": "Koad derv teñval dirusket",
  "block.minecraft.stripped_jungle_log": "Etev koad janglenn dirusket",
  "block.minecraft.stripped_jungle_wood": "Koad janglenn dirusket",
  "block.minecraft.stripped_mangrove_log": "Kef manglez dirusket",
  "block.minecraft.stripped_mangrove_wood": "Koad manglez dirusket",
  "block.minecraft.stripped_oak_log": "Etev derv dirusket",
  "block.minecraft.stripped_oak_wood": "Koad derv dirusket",
  "block.minecraft.stripped_pale_oak_log": "Etev derv disliv dirusket",
  "block.minecraft.stripped_pale_oak_wood": "Koad derv disliv dirusket",
  "block.minecraft.stripped_spruce_log": "Etev pruñs dirusket",
  "block.minecraft.stripped_spruce_wood": "Koad pruñs dirusket",
  "block.minecraft.stripped_warped_hyphae": "Hifennoù disleber dirusket",
  "block.minecraft.stripped_warped_stem": "Korzenn disleber dirusket",
  "block.minecraft.structure_block": "Bloc'h savadur",
  "block.minecraft.structure_void": "Goullonder frammad",
  "block.minecraft.sugar_cane": "Korzenn sukr",
  "block.minecraft.sunflower": "Tro-heol",
  "block.minecraft.suspicious_gravel": "Grouan touellus",
  "block.minecraft.suspicious_sand": "Traezh touellus",
  "block.minecraft.sweet_berry_bush": "Bod skav sukret",
  "block.minecraft.tall_dry_grass": "Geot sec'h uhel",
  "block.minecraft.tall_grass": "Geot uhel",
  "block.minecraft.tall_seagrass": "Geot mor uhel",
  "block.minecraft.target": "Bukenn",
  "block.minecraft.terracotta": "Pri poazh",
  "block.minecraft.test_block": "Bloc'h amprouiñ",
  "block.minecraft.test_instance_block": "Bloc'h istañs an amprouenn",
  "block.minecraft.tinted_glass": "Gwer livet",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "Diweredekaet eo tarzhadennoù an TNT",
  "block.minecraft.torch": "Etev-gouloù",
  "block.minecraft.torchflower": "Bleunienn-flamm",
  "block.minecraft.torchflower_crop": "Strujenn vleunienn-flamm",
  "block.minecraft.trapped_chest": "Koufr trapet",
  "block.minecraft.trial_spawner": "Ganerez an daeoù",
  "block.minecraft.tripwire": "Neudenn ziaskañ",
  "block.minecraft.tripwire_hook": "Krog neudenn ziaskañ",
  "block.minecraft.tube_coral": "Koural korzennek",
  "block.minecraft.tube_coral_block": "Bloc'h koural korzennek",
  "block.minecraft.tube_coral_fan": "Aveler koural korzennek",
  "block.minecraft.tube_coral_wall_fan": "Aveler moger koural korzennek",
  "block.minecraft.tuff": "Tuf",
  "block.minecraft.tuff_brick_slab": "Dar brikennoù tuf",
  "block.minecraft.tuff_brick_stairs": "Diri brikennoù tuf",
  "block.minecraft.tuff_brick_wall": "Moger brikennoù tuf",
  "block.minecraft.tuff_bricks": "Brikennoù tuf",
  "block.minecraft.tuff_slab": "Dar tuf",
  "block.minecraft.tuff_stairs": "Diri tuf",
  "block.minecraft.tuff_wall": "Moger tuf",
  "block.minecraft.turtle_egg": "Vi baot",
  "block.minecraft.twisting_vines": "Lianennoù troidellek",
  "block.minecraft.twisting_vines_plant": "Plant lianennoù troidellek",
  "block.minecraft.vault": "Armel-houarn",
  "block.minecraft.verdant_froglight": "Tousegouloù glasvezus",
  "block.minecraft.vine": "Lianennoù",
  "block.minecraft.void_air": "Aer ar goullonder",
  "block.minecraft.wall_torch": "Etev-gouloù moger",
  "block.minecraft.warped_button": "Bouton disleber",
  "block.minecraft.warped_door": "Dor disleber",
  "block.minecraft.warped_fence": "Kloued disleber",
  "block.minecraft.warped_fence_gate": "Dorikell disleber",
  "block.minecraft.warped_fungus": "Kabell-touseg disleber",
  "block.minecraft.warped_hanging_sign": "Panell disleber a-ispilh",
  "block.minecraft.warped_hyphae": "Hifennoù disleber",
  "block.minecraft.warped_nylium": "Niliom disleber",
  "block.minecraft.warped_planks": "Plankennoù disleber",
  "block.minecraft.warped_pressure_plate": "Plakenn wask disleber",
  "block.minecraft.warped_roots": "Gwrizioù disleber",
  "block.minecraft.warped_shelf": "Stalenn disleber",
  "block.minecraft.warped_sign": "Panell disleber",
  "block.minecraft.warped_slab": "Dar disleber",
  "block.minecraft.warped_stairs": "Diri disleber",
  "block.minecraft.warped_stem": "Korzenn disleber",
  "block.minecraft.warped_trapdoor": "Trap disleber",
  "block.minecraft.warped_wall_hanging_sign": "Panell-voger disleber a-ispilh",
  "block.minecraft.warped_wall_sign": "Panell-voger disleber",
  "block.minecraft.warped_wart_block": "Bloc'h gwenaenn disleber",
  "block.minecraft.water": "Dour",
  "block.minecraft.water_cauldron": "Kaoter dour",
  "block.minecraft.waxed_chiseled_copper": "Kouevr kizellet koaret",
  "block.minecraft.waxed_copper_bars": "Barrennoù kouevr koaret",
  "block.minecraft.waxed_copper_block": "Bloc'h kouevr koaret",
  "block.minecraft.waxed_copper_bulb": "Kleuzeur gouevr koaret",
  "block.minecraft.waxed_copper_chain": "Chadenn gouevr koaret",
  "block.minecraft.waxed_copper_chest": "Koufr kouevr koaret",
  "block.minecraft.waxed_copper_door": "Dor gouevr koaret",
  "block.minecraft.waxed_copper_golem_statue": "Delwenn golem kouevr koaret",
  "block.minecraft.waxed_copper_grate": "Kael gouevr koaret",
  "block.minecraft.waxed_copper_lantern": "Letern kouevr koaret",
  "block.minecraft.waxed_copper_trapdoor": "Trap kouevr koaret",
  "block.minecraft.waxed_cut_copper": "Kouevr benet koaret",
  "block.minecraft.waxed_cut_copper_slab": "Dar gouevr benet koaret",
  "block.minecraft.waxed_cut_copper_stairs": "Diri kouevr benet koaret",
  "block.minecraft.waxed_exposed_chiseled_copper": "Kouevr kizellet abimet koaret",
  "block.minecraft.waxed_exposed_copper": "Kouevr abimet koaret",
  "block.minecraft.waxed_exposed_copper_bars": "Barrennoù kouevr abimet koaret",
  "block.minecraft.waxed_exposed_copper_bulb": "Kleuzeur gouevr abimet koaret",
  "block.minecraft.waxed_exposed_copper_chain": "Chadenn gouevr abimet koaret",
  "block.minecraft.waxed_exposed_copper_chest": "Koufr kouevr abimet koaret",
  "block.minecraft.waxed_exposed_copper_door": "Dor gouevr abimet koaret",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Delwenn golem kouevr abimet koaret",
  "block.minecraft.waxed_exposed_copper_grate": "Kael gouevr abimet koaret",
  "block.minecraft.waxed_exposed_copper_lantern": "Letern kouevr abimet koaret",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Trap kouevr abimet koaret",
  "block.minecraft.waxed_exposed_cut_copper": "Kouevr benet abimet koaret",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Dar gouevr benet abimet koaret",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Diri kouevr benet abimet koaret",
  "block.minecraft.waxed_exposed_lightning_rod": "Diskuruner abimet koaret",
  "block.minecraft.waxed_lightning_rod": "Diskuruner koaret",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Kouevr kizellet merglet koaret",
  "block.minecraft.waxed_oxidized_copper": "Kouevr merglet koaret",
  "block.minecraft.waxed_oxidized_copper_bars": "Barrennoù kouevr merglet koaret",
  "block.minecraft.waxed_oxidized_copper_bulb": "Kleuzeur gouevr merglet koaret",
  "block.minecraft.waxed_oxidized_copper_chain": "Chadenn gouevr merglet koaret",
  "block.minecraft.waxed_oxidized_copper_chest": "Koufr kouevr merglet koaret",
  "block.minecraft.waxed_oxidized_copper_door": "Dor gouevr merglet koaret",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Delwenn golem kouevr merglet koaret",
  "block.minecraft.waxed_oxidized_copper_grate": "Kael gouevr merglet koaret",
  "block.minecraft.waxed_oxidized_copper_lantern": "Letern kouevr merglet koaret",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Trap kouevr merglet koaret",
  "block.minecraft.waxed_oxidized_cut_copper": "Kouevr benet merglet koaret",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Dar gouevr benet merglet koaret",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Diri kouevr benet merglet koaret",
  "block.minecraft.waxed_oxidized_lightning_rod": "Diskuruner merglet koaret",
  "block.minecraft.waxed_weathered_chiseled_copper": "Kouevr kizellet krignet koaret",
  "block.minecraft.waxed_weathered_copper": "Kouevr krignet koaret",
  "block.minecraft.waxed_weathered_copper_bars": "Barrennoù kouevr krignet koaret",
  "block.minecraft.waxed_weathered_copper_bulb": "Kleuzeur gouevr krignet koaret",
  "block.minecraft.waxed_weathered_copper_chain": "Chadenn gouevr krignet koaret",
  "block.minecraft.waxed_weathered_copper_chest": "Koufr kouevr krignet koaret",
  "block.minecraft.waxed_weathered_copper_door": "Dor gouevr krignet koaret",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Delwenn golem kouevr krignet koaret",
  "block.minecraft.waxed_weathered_copper_grate": "Kael gouevr krignet koaret",
  "block.minecraft.waxed_weathered_copper_lantern": "Letern kouevr krignet koaret",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Trap kouevr krignet koaret",
  "block.minecraft.waxed_weathered_cut_copper": "Kouevr benet krignet koaret",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Dar gouevr benet krignet koaret",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Diri kouevr benet krignet koaret",
  "block.minecraft.waxed_weathered_lightning_rod": "Diskuruner krignet koaret",
  "block.minecraft.weathered_chiseled_copper": "Kouevr kizellet krignet",
  "block.minecraft.weathered_copper": "Kouevr krignet",
  "block.minecraft.weathered_copper_bars": "Barrennoù kouevr krignet",
  "block.minecraft.weathered_copper_bulb": "Kleuzeur gouevr krignet",
  "block.minecraft.weathered_copper_chain": "Chadenn gouevr krignet",
  "block.minecraft.weathered_copper_chest": "Koufr kouevr krignet",
  "block.minecraft.weathered_copper_door": "Dor gouevr krignet",
  "block.minecraft.weathered_copper_golem_statue": "Delwenn golem kouevr krignet",
  "block.minecraft.weathered_copper_grate": "Kael gouevr krignet",
  "block.minecraft.weathered_copper_lantern": "Letern kouevr krignet",
  "block.minecraft.weathered_copper_trapdoor": "Trap kouevr krignet",
  "block.minecraft.weathered_cut_copper": "Kouevr benet krignet",
  "block.minecraft.weathered_cut_copper_slab": "Dar gouevr benet krignet",
  "block.minecraft.weathered_cut_copper_stairs": "Diri kouevr benet krignet",
  "block.minecraft.weathered_lightning_rod": "Diskuruner krignet",
  "block.minecraft.weeping_vines": "Lianennoù goueler",
  "block.minecraft.weeping_vines_plant": "Plant lianennoù goueler",
  "block.minecraft.wet_sponge": "Spoueenn c'hleb",
  "block.minecraft.wheat": "Plant ed",
  "block.minecraft.white_banner": "Banniel gwenn",
  "block.minecraft.white_bed": "Gwele gwenn",
  "block.minecraft.white_candle": "Boujienn wenn",
  "block.minecraft.white_candle_cake": "Gwastell gant ur voujienn wenn",
  "block.minecraft.white_carpet": "Pallenn gwenn",
  "block.minecraft.white_concrete": "Betoñs gwenn",
  "block.minecraft.white_concrete_powder": "Poultr betoñs gwenn",
  "block.minecraft.white_glazed_terracotta": "Pri poazh amailhet gwenn",
  "block.minecraft.white_shulker_box": "Boest Shulker wenn",
  "block.minecraft.white_stained_glass": "Gwer gwenn",
  "block.minecraft.white_stained_glass_pane": "Gwerenn wenn",
  "block.minecraft.white_terracotta": "Pri poazh gwenn",
  "block.minecraft.white_tulip": "Tulipezenn wenn",
  "block.minecraft.white_wool": "Gloan gwenn",
  "block.minecraft.wildflowers": "Bleunioù gouez",
  "block.minecraft.wither_rose": "Rozenn Wither",
  "block.minecraft.wither_skeleton_skull": "Klopenn Wither",
  "block.minecraft.wither_skeleton_wall_skull": "Klopenn Wither moger",
  "block.minecraft.yellow_banner": "Banniel melen",
  "block.minecraft.yellow_bed": "Gwele melen",
  "block.minecraft.yellow_candle": "Boujienn velen",
  "block.minecraft.yellow_candle_cake": "Gwastell gant ur voujienn velen",
  "block.minecraft.yellow_carpet": "Pallenn melen",
  "block.minecraft.yellow_concrete": "Betoñs melen",
  "block.minecraft.yellow_concrete_powder": "Poultr betoñs melen",
  "block.minecraft.yellow_glazed_terracotta": "Pri poazh amailhet melen",
  "block.minecraft.yellow_shulker_box": "Boest Shulker velen",
  "block.minecraft.yellow_stained_glass": "Gwer melen",
  "block.minecraft.yellow_stained_glass_pane": "Gwerenn velen",
  "block.minecraft.yellow_terracotta": "Pri poazh melen",
  "block.minecraft.yellow_wool": "Gloan melen",
  "block.minecraft.zombie_head": "Penn zombi",
  "block.minecraft.zombie_wall_head": "Penn zombi moger",
  "item.minecraft.acacia_boat": "Bag kasia",
  "item.minecraft.acacia_chest_boat": "Bag kasia gant ur c'houfr",
  "item.minecraft.allay_spawn_egg": "Vi genel Allay",
  "item.minecraft.amethyst_shard": "Strinkenn ametist",
  "item.minecraft.angler_pottery_shard": "Darbod ar pesketaer",
  "item.minecraft.angler_pottery_sherd": "Darbod ar pesketaer",
  "item.minecraft.apple": "Aval",
  "item.minecraft.archer_pottery_shard": "Darbod ar gwareger",
  "item.minecraft.archer_pottery_sherd": "Darbod ar gwareger",
  "item.minecraft.armadillo_scute": "Skantenn datou",
  "item.minecraft.armadillo_spawn_egg": "Vi genel tatou",
  "item.minecraft.armor_stand": "Douger houarnwisk",
  "item.minecraft.arms_up_pottery_shard": "Darbod an den",
  "item.minecraft.arms_up_pottery_sherd": "Darbod an den",
  "item.minecraft.arrow": "Bir",
  "item.minecraft.axolotl_bucket": "Sailhad axolotl",
  "item.minecraft.axolotl_spawn_egg": "Vi genel axolotl",
  "item.minecraft.baked_potato": "Aval-douar poazh",
  "item.minecraft.bamboo_chest_raft": "Radell vambouz gant ur c'houfr",
  "item.minecraft.bamboo_raft": "Radell vambouz",
  "item.minecraft.bat_spawn_egg": "Vi genel askell-groc'hen",
  "item.minecraft.bee_spawn_egg": "Vi genel gwenan",
  "item.minecraft.beef": "Kig-bevin kriz",
  "item.minecraft.beetroot": "Beterabezenn",
  "item.minecraft.beetroot_seeds": "Greun beterabez",
  "item.minecraft.beetroot_soup": "Soubenn veterabez",
  "item.minecraft.birch_boat": "Bag vezv",
  "item.minecraft.birch_chest_boat": "Bag vezv gant ur c'houfr",
  "item.minecraft.black_bundle": "Sac'h du",
  "item.minecraft.black_dye": "Livadenn du",
  "item.minecraft.black_harness": "Sternaj du",
  "item.minecraft.blade_pottery_shard": "Darbod ar c'hleze",
  "item.minecraft.blade_pottery_sherd": "Darbod ar c'hleze",
  "item.minecraft.blaze_powder": "Poultr Blaze",
  "item.minecraft.blaze_rod": "Bazh tan",
  "item.minecraft.blaze_spawn_egg": "Vi genel Blaze",
  "item.minecraft.blue_bundle": "Sac'h glas",
  "item.minecraft.blue_dye": "Livadenn c'hlas",
  "item.minecraft.blue_egg": "Vi glas",
  "item.minecraft.blue_harness": "Sternaj glas",
  "item.minecraft.bogged_spawn_egg": "Vi genel geuniad",
  "item.minecraft.bolt_armor_trim_smithing_template": "Patrom goveliañ",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Kinkladur an ibil-houarn",
  "item.minecraft.bone": "Askorn",
  "item.minecraft.bone_meal": "Poultr eskern",
  "item.minecraft.book": "Levr",
  "item.minecraft.bordure_indented_banner_pattern": "Patrom banniel ar vevenn kranellet",
  "item.minecraft.bow": "Gwareg",
  "item.minecraft.bowl": "Bolenn",
  "item.minecraft.bread": "Bara",
  "item.minecraft.breeze_rod": "Bazh avel",
  "item.minecraft.breeze_spawn_egg": "Vi genel gwent",
  "item.minecraft.brewer_pottery_shard": "Darbod an alkimiezh",
  "item.minecraft.brewer_pottery_sherd": "Darbod an alkimiezh",
  "item.minecraft.brewing_stand": "Lambig",
  "item.minecraft.brick": "Brikenn",
  "item.minecraft.brown_bundle": "Sac'h gell",
  "item.minecraft.brown_dye": "Livadenn c'hell",
  "item.minecraft.brown_egg": "Vi gell",
  "item.minecraft.brown_harness": "Sternaj gell",
  "item.minecraft.brush": "Broust",
  "item.minecraft.bucket": "Sailh",
  "item.minecraft.bundle": "Sac'h",
  "item.minecraft.bundle.empty": "Goullo",
  "item.minecraft.bundle.empty.description": "Gallout a ra derc'hel ur berniad a objedoù",
  "item.minecraft.bundle.full": "Leun",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Darbod an tan",
  "item.minecraft.burn_pottery_sherd": "Darbod an tan",
  "item.minecraft.camel_husk_spawn_egg": "Vi genel dremedal disec'het",
  "item.minecraft.camel_spawn_egg": "Vi genel dremedal",
  "item.minecraft.carrot": "Karotezenn",
  "item.minecraft.carrot_on_a_stick": "Karotezenn ouzh ur vazh",
  "item.minecraft.cat_spawn_egg": "Vi genel kazh",
  "item.minecraft.cauldron": "Kaoter",
  "item.minecraft.cave_spider_spawn_egg": "Vi genel kevnidenn vougev",
  "item.minecraft.chainmail_boots": "Botoù mailhek",
  "item.minecraft.chainmail_chestplate": "Sae-vailhek",
  "item.minecraft.chainmail_helmet": "Tokarn mailhek",
  "item.minecraft.chainmail_leggings": "Bragoù mailhek",
  "item.minecraft.charcoal": "Glaou koad",
  "item.minecraft.cherry_boat": "Bag koad-kerez",
  "item.minecraft.cherry_chest_boat": "Bag koad-kerez gant ur c'houfr",
  "item.minecraft.chest_minecart": "Bagon vengleuz gant ur c'houfr",
  "item.minecraft.chicken": "Kig-yar kriz",
  "item.minecraft.chicken_spawn_egg": "Vi genel yar",
  "item.minecraft.chorus_fruit": "Frouezhenn gorus",
  "item.minecraft.clay_ball": "Boulenn pri",
  "item.minecraft.clock": "Eurier",
  "item.minecraft.coal": "Glaouenn",
  "item.minecraft.coast_armor_trim_smithing_template": "Patrom goveliañ",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Kinkladur an aod",
  "item.minecraft.cocoa_beans": "Fav kakao",
  "item.minecraft.cod": "Moru kriz",
  "item.minecraft.cod_bucket": "Sailhad moru",
  "item.minecraft.cod_spawn_egg": "Vi genel moru",
  "item.minecraft.command_block_minecart": "Bagon vengleuz gant ur bloc'h urzhiañ",
  "item.minecraft.compass": "Nadoz-vor",
  "item.minecraft.cooked_beef": "Kig-bevin poazh",
  "item.minecraft.cooked_chicken": "Kig-yar poazh",
  "item.minecraft.cooked_cod": "Moru poazh",
  "item.minecraft.cooked_mutton": "Kig-dañvad poazh",
  "item.minecraft.cooked_porkchop": "Kig-moc'h poazh",
  "item.minecraft.cooked_rabbit": "Kig-konikl poazh",
  "item.minecraft.cooked_salmon": "Eog poazh",
  "item.minecraft.cookie": "Gwispidenn",
  "item.minecraft.copper_axe": "Bouc'hal gouevr",
  "item.minecraft.copper_boots": "Botoù kouevr",
  "item.minecraft.copper_chestplate": "Brennid kouevr",
  "item.minecraft.copper_golem_spawn_egg": "Vi genel golem kouevr",
  "item.minecraft.copper_helmet": "Tokarn kouevr",
  "item.minecraft.copper_hoe": "Mar gouevr",
  "item.minecraft.copper_horse_armor": "Harnez marc'h kouevr",
  "item.minecraft.copper_ingot": "Barrenn gouevr",
  "item.minecraft.copper_leggings": "Bragoù kouevr",
  "item.minecraft.copper_nautilus_armor": "Harnez naotil kouevr",
  "item.minecraft.copper_nugget": "Malzenn gouevr",
  "item.minecraft.copper_pickaxe": "Pigell gouevr",
  "item.minecraft.copper_shovel": "Pal gouevr",
  "item.minecraft.copper_spear": "Goaf kouevr",
  "item.minecraft.copper_sword": "Kleze kouevr",
  "item.minecraft.cow_spawn_egg": "Vi genel buoc'h",
  "item.minecraft.creaking_spawn_egg": "Vi genel gwigour",
  "item.minecraft.creeper_banner_pattern": "Patrom banniel",
  "item.minecraft.creeper_banner_pattern.desc": "Penn Creeper",
  "item.minecraft.creeper_banner_pattern.new": "Patrom banniel ar penn Creeper",
  "item.minecraft.creeper_spawn_egg": "Vi genel Creeper",
  "item.minecraft.crossbow": "Kroazwareg",
  "item.minecraft.crossbow.projectile": "Bannadell:",
  "item.minecraft.crossbow.projectile.multiple": "Bannadell: %s × %s",
  "item.minecraft.crossbow.projectile.single": "Bannadell: %s",
  "item.minecraft.cyan_bundle": "Sac'h sian",
  "item.minecraft.cyan_dye": "Livadenn sian",
  "item.minecraft.cyan_harness": "Sternaj sian",
  "item.minecraft.danger_pottery_shard": "Darbod an dañjer",
  "item.minecraft.danger_pottery_sherd": "Darbod an dañjer",
  "item.minecraft.dark_oak_boat": "Bag derv teñval",
  "item.minecraft.dark_oak_chest_boat": "Bag derv teñval gant ur c'houfr",
  "item.minecraft.debug_stick": "Bazh difaziañ",
  "item.minecraft.debug_stick.empty": "N'eus perzh ebet gant %s",
  "item.minecraft.debug_stick.select": "diuzet \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" da %s",
  "item.minecraft.diamond": "Diamant",
  "item.minecraft.diamond_axe": "Bouc'hal ziamant",
  "item.minecraft.diamond_boots": "Botoù diamant",
  "item.minecraft.diamond_chestplate": "Brennid diamant",
  "item.minecraft.diamond_helmet": "Tokarn diamant",
  "item.minecraft.diamond_hoe": "Marr ziamant",
  "item.minecraft.diamond_horse_armor": "Harnez marc'h diamant",
  "item.minecraft.diamond_leggings": "Bragoù diamant",
  "item.minecraft.diamond_nautilus_armor": "Harnez naotil diamant",
  "item.minecraft.diamond_pickaxe": "Pigell ziamant",
  "item.minecraft.diamond_shovel": "Pal diamant",
  "item.minecraft.diamond_spear": "Goaf diamant",
  "item.minecraft.diamond_sword": "Kleze diamant",
  "item.minecraft.disc_fragment_5": "Tamm pladenn",
  "item.minecraft.disc_fragment_5.desc": "Pladenn sonerezh - 5",
  "item.minecraft.dolphin_spawn_egg": "Vi genel delfin",
  "item.minecraft.donkey_spawn_egg": "Vi genel azen",
  "item.minecraft.dragon_breath": "C'hwezh an Aerouant",
  "item.minecraft.dried_kelp": "Bezhin sec'het",
  "item.minecraft.drowned_spawn_egg": "Vi genel beuzed",
  "item.minecraft.dune_armor_trim_smithing_template": "Patrom goveliañ",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Kinkladur an tevenn",
  "item.minecraft.echo_shard": "Darbod dasson",
  "item.minecraft.egg": "Vi",
  "item.minecraft.elder_guardian_spawn_egg": "Vi genel diwaller meur",
  "item.minecraft.elytra": "Adeskell",
  "item.minecraft.emerald": "Emrodez",
  "item.minecraft.enchanted_book": "Levr strobinellet",
  "item.minecraft.enchanted_golden_apple": "Aval alaouret strobinellet",
  "item.minecraft.end_crystal": "Strink an End",
  "item.minecraft.ender_dragon_spawn_egg": "Vi genel Aerouant an End",
  "item.minecraft.ender_eye": "Lagad an End",
  "item.minecraft.ender_pearl": "Perlezenn an End",
  "item.minecraft.enderman_spawn_egg": "Vi genel Enderman",
  "item.minecraft.endermite_spawn_egg": "Vi genel Endermite",
  "item.minecraft.evoker_spawn_egg": "Vi genel dec'halver",
  "item.minecraft.experience_bottle": "Braoued strobinellerezh",
  "item.minecraft.explorer_pottery_shard": "Darbod an ergerzher",
  "item.minecraft.explorer_pottery_sherd": "Darbod an ergerzher",
  "item.minecraft.eye_armor_trim_smithing_template": "Patrom goveliañ",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Kinkladur al lagad",
  "item.minecraft.feather": "Pluenn",
  "item.minecraft.fermented_spider_eye": "Lagad kevnidenn c'hoellet",
  "item.minecraft.field_masoned_banner_pattern": "Patrom banniel ar voger",
  "item.minecraft.filled_map": "Kartenn",
  "item.minecraft.fire_charge": "Karg tan",
  "item.minecraft.firework_rocket": "Fuc'hell tan-arvest",
  "item.minecraft.firework_rocket.flight": "Padelezh an nijadenn:",
  "item.minecraft.firework_rocket.multiple_stars": "%s × %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Steredenn tan-arvest",
  "item.minecraft.firework_star.black": "Du",
  "item.minecraft.firework_star.blue": "Glas",
  "item.minecraft.firework_star.brown": "Gell",
  "item.minecraft.firework_star.custom_color": "Personelaet",
  "item.minecraft.firework_star.cyan": "Sian",
  "item.minecraft.firework_star.fade_to": "Arveuz da",
  "item.minecraft.firework_star.flicker": "Fulennoù",
  "item.minecraft.firework_star.gray": "Griz",
  "item.minecraft.firework_star.green": "Gwer",
  "item.minecraft.firework_star.light_blue": "Glas sklaer",
  "item.minecraft.firework_star.light_gray": "Griz sklaer",
  "item.minecraft.firework_star.lime": "Gwer-melen",
  "item.minecraft.firework_star.magenta": "Majenta",
  "item.minecraft.firework_star.orange": "Orañjez",
  "item.minecraft.firework_star.pink": "Roz",
  "item.minecraft.firework_star.purple": "Mouk",
  "item.minecraft.firework_star.red": "Ruz",
  "item.minecraft.firework_star.shape": "Stumm dianav",
  "item.minecraft.firework_star.shape.burst": "Tarzhadenn",
  "item.minecraft.firework_star.shape.creeper": "Stumm ur c'hreeper",
  "item.minecraft.firework_star.shape.large_ball": "Bolotenn vras",
  "item.minecraft.firework_star.shape.small_ball": "Bolotenn vihan",
  "item.minecraft.firework_star.shape.star": "Stumm ur steredenn",
  "item.minecraft.firework_star.trail": "Roudoù",
  "item.minecraft.firework_star.white": "Gwenn",
  "item.minecraft.firework_star.yellow": "Melen",
  "item.minecraft.fishing_rod": "Gwalenn-besketa",
  "item.minecraft.flint": "Kailhastr",
  "item.minecraft.flint_and_steel": "Kailhastr ha dir",
  "item.minecraft.flow_armor_trim_smithing_template": "Patrom goveliañ",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Kinkladur ar gorventenn",
  "item.minecraft.flow_banner_pattern": "Patrom banniel",
  "item.minecraft.flow_banner_pattern.desc": "Korventenn",
  "item.minecraft.flow_banner_pattern.new": "Patrom banniel ar gorventenn",
  "item.minecraft.flow_pottery_sherd": "Darbod ar gorventenn",
  "item.minecraft.flower_banner_pattern": "Patrom banniel",
  "item.minecraft.flower_banner_pattern.desc": "Penn bleunienn",
  "item.minecraft.flower_banner_pattern.new": "Patrom banniel ar vleunienn",
  "item.minecraft.flower_pot": "Pod bleunioù",
  "item.minecraft.fox_spawn_egg": "Vi genel louarn",
  "item.minecraft.friend_pottery_shard": "Darbod ar mignon",
  "item.minecraft.friend_pottery_sherd": "Darbod ar mignon",
  "item.minecraft.frog_spawn_egg": "Vi genel glesker",
  "item.minecraft.furnace_minecart": "Bagon vengleuz gant ur forn",
  "item.minecraft.ghast_spawn_egg": "Vi genel Ghast",
  "item.minecraft.ghast_tear": "Daerenn Ghast",
  "item.minecraft.glass_bottle": "Boutailh wer",
  "item.minecraft.glistering_melon_slice": "Lodenn sukrinenn lufrus",
  "item.minecraft.globe_banner_pattern": "Patrom banniel",
  "item.minecraft.globe_banner_pattern.desc": "Boul",
  "item.minecraft.globe_banner_pattern.new": "Patrom banniel ar bed",
  "item.minecraft.glow_berries": "Skav lugernus",
  "item.minecraft.glow_ink_sac": "Sac'h ankr lugernus",
  "item.minecraft.glow_item_frame": "Stern lufrus",
  "item.minecraft.glow_squid_spawn_egg": "Vi genel stiogan lugernus",
  "item.minecraft.glowstone_dust": "Poultr lufrus",
  "item.minecraft.goat_horn": "Korn gavr",
  "item.minecraft.goat_spawn_egg": "Vi genel gavr",
  "item.minecraft.gold_ingot": "Barrenn aour",
  "item.minecraft.gold_nugget": "Malzenn aour",
  "item.minecraft.golden_apple": "Aval alaouret",
  "item.minecraft.golden_axe": "Bouc'hal aour",
  "item.minecraft.golden_boots": "Botoù aour",
  "item.minecraft.golden_carrot": "Karotezenn alaouret",
  "item.minecraft.golden_chestplate": "Brennid aour",
  "item.minecraft.golden_helmet": "Tokarn aour",
  "item.minecraft.golden_hoe": "Marr aour",
  "item.minecraft.golden_horse_armor": "Harnez marc'h alaouret",
  "item.minecraft.golden_leggings": "Bragoù aour",
  "item.minecraft.golden_nautilus_armor": "Harnez naotil alaouret",
  "item.minecraft.golden_pickaxe": "Pigell aour",
  "item.minecraft.golden_shovel": "Pal aour",
  "item.minecraft.golden_spear": "Goaf aour",
  "item.minecraft.golden_sword": "Kleze aour",
  "item.minecraft.gray_bundle": "Sac'h gris",
  "item.minecraft.gray_dye": "Livadenn c'hris",
  "item.minecraft.gray_harness": "Sternaj gris",
  "item.minecraft.green_bundle": "Sac'h gwer",
  "item.minecraft.green_dye": "Livadenn wer",
  "item.minecraft.green_harness": "Sternaj gwer",
  "item.minecraft.guardian_spawn_egg": "Vi genel diwaller",
  "item.minecraft.gunpowder": "Poultr kanol",
  "item.minecraft.guster_banner_pattern": "Patrom banniel",
  "item.minecraft.guster_banner_pattern.desc": "Gwent",
  "item.minecraft.guster_banner_pattern.new": "Patrom banniel ar gwent",
  "item.minecraft.guster_pottery_sherd": "Darbod ar gwent",
  "item.minecraft.happy_ghast_spawn_egg": "Vi genel Ghast eürus",
  "item.minecraft.harness": "Sternaj",
  "item.minecraft.heart_of_the_sea": "Kalon ar mor",
  "item.minecraft.heart_pottery_shard": "Darbod ar galon",
  "item.minecraft.heart_pottery_sherd": "Darbod ar galon",
  "item.minecraft.heartbreak_pottery_shard": "Darbod ar galon flastret",
  "item.minecraft.heartbreak_pottery_sherd": "Darbod ar galon flastret",
  "item.minecraft.hoglin_spawn_egg": "Vi genel Hoglin",
  "item.minecraft.honey_bottle": "Boutailhad mel",
  "item.minecraft.honeycomb": "Follenn goar",
  "item.minecraft.hopper_minecart": "Bagon vengleuz gant ur founilh",
  "item.minecraft.horse_spawn_egg": "Vi genel marc'h",
  "item.minecraft.host_armor_trim_smithing_template": "Patrom goveliañ",
  "item.minecraft.host_armor_trim_smithing_template.new": "Kinkladur an ostiz",
  "item.minecraft.howl_pottery_shard": "Darbod ar bleiz",
  "item.minecraft.howl_pottery_sherd": "Darbod ar bleiz",
  "item.minecraft.husk_spawn_egg": "Vi genel disec'han",
  "item.minecraft.ink_sac": "Sac'h ankr",
  "item.minecraft.iron_axe": "Bouc'hal houarn",
  "item.minecraft.iron_boots": "Botoù houarn",
  "item.minecraft.iron_chestplate": "Brennid houarn",
  "item.minecraft.iron_golem_spawn_egg": "Vi genel golem-houarn",
  "item.minecraft.iron_helmet": "Tokarn houarn",
  "item.minecraft.iron_hoe": "Marr houarn",
  "item.minecraft.iron_horse_armor": "Houarnwisk marc'h",
  "item.minecraft.iron_ingot": "Barrenn houarn",
  "item.minecraft.iron_leggings": "Bragoù houarn",
  "item.minecraft.iron_nautilus_armor": "Houarnwisk naotil",
  "item.minecraft.iron_nugget": "Malzenn houarn",
  "item.minecraft.iron_pickaxe": "Pigell houarn",
  "item.minecraft.iron_shovel": "Pal houarn",
  "item.minecraft.iron_spear": "Goaf houarn",
  "item.minecraft.iron_sword": "Kleze houarn",
  "item.minecraft.item_frame": "Stern",
  "item.minecraft.jungle_boat": "Bag koad janglenn",
  "item.minecraft.jungle_chest_boat": "Bag koad janglenn gant ur c'houfr",
  "item.minecraft.knowledge_book": "Levr ar Ouiziegezh",
  "item.minecraft.lapis_lazuli": "Lapis Lazuli",
  "item.minecraft.lava_bucket": "Sailhad lava",
  "item.minecraft.lead": "Lêrenn",
  "item.minecraft.leather": "Lêr",
  "item.minecraft.leather_boots": "Botoù lêr",
  "item.minecraft.leather_chestplate": "Sae lêr",
  "item.minecraft.leather_helmet": "Tok lêr",
  "item.minecraft.leather_horse_armor": "Harnez marc'h lêr",
  "item.minecraft.leather_leggings": "Bragoù lêr",
  "item.minecraft.light_blue_bundle": "Sac'h glas sklaer",
  "item.minecraft.light_blue_dye": "Livadenn c'hlas sklaer",
  "item.minecraft.light_blue_harness": "Sternaj glas sklaer",
  "item.minecraft.light_gray_bundle": "Sac'h gris sklaer",
  "item.minecraft.light_gray_dye": "Livadenn c'hris sklaer",
  "item.minecraft.light_gray_harness": "Sternaj gris sklaer",
  "item.minecraft.lime_bundle": "Sac'h gwer sklaer",
  "item.minecraft.lime_dye": "Livadenn wer-melen",
  "item.minecraft.lime_harness": "Sternaj gwer sklaer",
  "item.minecraft.lingering_potion": "Braoued padus",
  "item.minecraft.lingering_potion.effect.awkward": "Braoued direnkus padus",
  "item.minecraft.lingering_potion.effect.empty": "N'haller ket aozañ ar braoued padus-mañ",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Braoued tan-gwarez padus",
  "item.minecraft.lingering_potion.effect.harming": "Braoued freuzañ padus",
  "item.minecraft.lingering_potion.effect.healing": "Braoued pareañ padus",
  "item.minecraft.lingering_potion.effect.infested": "Braoued kontroniñ padus",
  "item.minecraft.lingering_potion.effect.invisibility": "Braoued diwelusted padus",
  "item.minecraft.lingering_potion.effect.leaping": "Braoued lammat padus",
  "item.minecraft.lingering_potion.effect.levitation": "Braoued nijal padus",
  "item.minecraft.lingering_potion.effect.luck": "Braoued chañs padus",
  "item.minecraft.lingering_potion.effect.mundane": "Braoued ordinal padus",
  "item.minecraft.lingering_potion.effect.night_vision": "Braoued gwelet en noz padus",
  "item.minecraft.lingering_potion.effect.oozing": "Braoued gludañ padus",
  "item.minecraft.lingering_potion.effect.poison": "Braoued ampoezon padus",
  "item.minecraft.lingering_potion.effect.regeneration": "Braoued empareañ padus",
  "item.minecraft.lingering_potion.effect.slow_falling": "Braoued kouezhañ gorrek padus",
  "item.minecraft.lingering_potion.effect.slowness": "Braoued gorregezh padus",
  "item.minecraft.lingering_potion.effect.strength": "Braoued kreñvder padus",
  "item.minecraft.lingering_potion.effect.swiftness": "Braoued primder padus",
  "item.minecraft.lingering_potion.effect.thick": "Braoued tev padus",
  "item.minecraft.lingering_potion.effect.turtle_master": "Braoued mestr ar baoted padus",
  "item.minecraft.lingering_potion.effect.water": "Braoued dour padus",
  "item.minecraft.lingering_potion.effect.water_breathing": "Braoued analañ en dour padus",
  "item.minecraft.lingering_potion.effect.weakness": "Braoued gwander padus",
  "item.minecraft.lingering_potion.effect.weaving": "Braoued gwiadiñ padus",
  "item.minecraft.lingering_potion.effect.wind_charged": "Braoued c'hwezh padus",
  "item.minecraft.llama_spawn_egg": "Vi genel lama",
  "item.minecraft.lodestone_compass": "Nadoz-vor maentouchek",
  "item.minecraft.mace": "Horzh",
  "item.minecraft.magenta_bundle": "Sac'h limestra",
  "item.minecraft.magenta_dye": "Livadenn vajenta",
  "item.minecraft.magenta_harness": "Sternaj limestra",
  "item.minecraft.magma_cream": "Dienn vagma",
  "item.minecraft.magma_cube_spawn_egg": "Vi genel kub magma",
  "item.minecraft.mangrove_boat": "Bag vanglez",
  "item.minecraft.mangrove_chest_boat": "Bag vanglez gant ur c'houfr",
  "item.minecraft.map": "Kartenn c'houllo",
  "item.minecraft.melon_seeds": "Greun sukrin",
  "item.minecraft.melon_slice": "Lodenn sukrinenn",
  "item.minecraft.milk_bucket": "Sailhad laezh",
  "item.minecraft.minecart": "Bagon vengleuz",
  "item.minecraft.miner_pottery_shard": "Darbod ar mengleuzier",
  "item.minecraft.miner_pottery_sherd": "Darbod ar mengleuzier",
  "item.minecraft.mojang_banner_pattern": "Patrom banniel",
  "item.minecraft.mojang_banner_pattern.desc": "Arouez",
  "item.minecraft.mojang_banner_pattern.new": "Patrom banniel an arouez",
  "item.minecraft.mooshroom_spawn_egg": "Vi genel mooshroom",
  "item.minecraft.mourner_pottery_shard": "Darbod ar c'hañver",
  "item.minecraft.mourner_pottery_sherd": "Darbod ar c'hañver",
  "item.minecraft.mule_spawn_egg": "Vi genel mulez",
  "item.minecraft.mushroom_stew": "Soubenn kabelloù-touseg",
  "item.minecraft.music_disc_11": "Pladenn sonerezh",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Pladenn sonerezh",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Pladenn sonerezh",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Pladenn sonerezh",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Pladenn sonerezh",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Pladenn sonerezh",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Pladenn sonerezh",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Pladenn sonerezh",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (boest sonerezh)",
  "item.minecraft.music_disc_far": "Pladenn sonerezh",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Pladenn sonerezh",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Pladenn sonerezh",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Pladenn sonerezh",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Pladenn sonerezh",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Pladenn sonerezh",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Pladenn sonerezh",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Pladenn sonerezh",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Pladenn sonerezh",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Pladenn sonerezh",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Pladenn sonerezh",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Pladenn sonerezh",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Pladenn sonerezh",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Kig-dañvad kriz",
  "item.minecraft.name_tag": "Tikedenn anv",
  "item.minecraft.nautilus_shell": "Krogenn naotil",
  "item.minecraft.nautilus_spawn_egg": "Vi genel naotiled",
  "item.minecraft.nether_brick": "Brikenn an Nether",
  "item.minecraft.nether_star": "Steredenn Nether",
  "item.minecraft.nether_wart": "Gwenaenn an Nether",
  "item.minecraft.netherite_axe": "Bouc'hal Netherite",
  "item.minecraft.netherite_boots": "Botoù Netherite",
  "item.minecraft.netherite_chestplate": "Brennid Netherite",
  "item.minecraft.netherite_helmet": "Tokarn Netherite",
  "item.minecraft.netherite_hoe": "Marr Netherite",
  "item.minecraft.netherite_horse_armor": "Harnez marc'h Netherite",
  "item.minecraft.netherite_ingot": "Barrenn Netherite",
  "item.minecraft.netherite_leggings": "Bragoù Netherite",
  "item.minecraft.netherite_nautilus_armor": "Harnez naotil Netherite",
  "item.minecraft.netherite_pickaxe": "Pigell Netherite",
  "item.minecraft.netherite_scrap": "Darnoù Netherite",
  "item.minecraft.netherite_shovel": "Pal Netherite",
  "item.minecraft.netherite_spear": "Goaf Netherite",
  "item.minecraft.netherite_sword": "Kleze Netherite",
  "item.minecraft.netherite_upgrade_smithing_template": "Patrom goveliañ",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Gwellaenn Netherite",
  "item.minecraft.oak_boat": "Bag derv",
  "item.minecraft.oak_chest_boat": "Bag derv gant ur c'houfr",
  "item.minecraft.ocelot_spawn_egg": "Vi genel oselo",
  "item.minecraft.ominous_bottle": "Boutailh skrijus",
  "item.minecraft.ominous_trial_key": "Alc'hwez an daeoù skrijus",
  "item.minecraft.orange_bundle": "Sac'h orañjez",
  "item.minecraft.orange_dye": "Livadenn orañjez",
  "item.minecraft.orange_harness": "Sternaj orañjez",
  "item.minecraft.painting": "Livadur",
  "item.minecraft.pale_oak_boat": "Bag derv disliv",
  "item.minecraft.pale_oak_chest_boat": "Bag derv disliv gant ur c'houfr",
  "item.minecraft.panda_spawn_egg": "Vi genel panda",
  "item.minecraft.paper": "Paper",
  "item.minecraft.parched_spawn_egg": "Vi genel balzamegenn",
  "item.minecraft.parrot_spawn_egg": "Vi genel peroked",
  "item.minecraft.phantom_membrane": "Kroc'henenn dasmant",
  "item.minecraft.phantom_spawn_egg": "Vi genel tasmant",
  "item.minecraft.pig_spawn_egg": "Vi genel pemoc'h",
  "item.minecraft.piglin_banner_pattern": "Patrom banniel",
  "item.minecraft.piglin_banner_pattern.desc": "Mojell",
  "item.minecraft.piglin_banner_pattern.new": "Patrom banniel ar vojell",
  "item.minecraft.piglin_brute_spawn_egg": "Vi genel Piglin gouez",
  "item.minecraft.piglin_spawn_egg": "Vi genel Piglin",
  "item.minecraft.pillager_spawn_egg": "Vi genel preizhataer",
  "item.minecraft.pink_bundle": "Sac'h roz",
  "item.minecraft.pink_dye": "Livadenn roz",
  "item.minecraft.pink_harness": "Sternaj roz",
  "item.minecraft.pitcher_plant": "Jarlili",
  "item.minecraft.pitcher_pod": "Klorenn jarlili",
  "item.minecraft.plenty_pottery_shard": "Darbod ar glad",
  "item.minecraft.plenty_pottery_sherd": "Darbod ar glad",
  "item.minecraft.poisonous_potato": "Aval-douar ampoezonet",
  "item.minecraft.polar_bear_spawn_egg": "Vi genel arzh gwenn",
  "item.minecraft.popped_chorus_fruit": "Frouezhenn gorus poazh",
  "item.minecraft.porkchop": "Kig-moc'h kriz",
  "item.minecraft.potato": "Aval-douar",
  "item.minecraft.potion": "Braoued",
  "item.minecraft.potion.effect.awkward": "Braoued direnkus",
  "item.minecraft.potion.effect.empty": "N'haller ket aozañ ar braoued-mañ",
  "item.minecraft.potion.effect.fire_resistance": "Braoued tan-gwarez",
  "item.minecraft.potion.effect.harming": "Braoued freuzañ",
  "item.minecraft.potion.effect.healing": "Braoued pareañ",
  "item.minecraft.potion.effect.infested": "Braoued kontroniñ",
  "item.minecraft.potion.effect.invisibility": "Braoued diwelusted",
  "item.minecraft.potion.effect.leaping": "Braoued lammat",
  "item.minecraft.potion.effect.levitation": "Braoued nijal",
  "item.minecraft.potion.effect.luck": "Braoued chañs",
  "item.minecraft.potion.effect.mundane": "Braoued ordinal",
  "item.minecraft.potion.effect.night_vision": "Braoued gweled en noz",
  "item.minecraft.potion.effect.oozing": "Braoued gludañ",
  "item.minecraft.potion.effect.poison": "Braoued ampoezon",
  "item.minecraft.potion.effect.regeneration": "Braoued empareañ",
  "item.minecraft.potion.effect.slow_falling": "Braoued kouezhañ gorrek",
  "item.minecraft.potion.effect.slowness": "Braoued gorregezh",
  "item.minecraft.potion.effect.strength": "Braoued kreñvder",
  "item.minecraft.potion.effect.swiftness": "Braoued primder",
  "item.minecraft.potion.effect.thick": "Braoued tev",
  "item.minecraft.potion.effect.turtle_master": "Braoued mestr ar baoted",
  "item.minecraft.potion.effect.water": "Boutailhad dour",
  "item.minecraft.potion.effect.water_breathing": "Braoued analañ en dour",
  "item.minecraft.potion.effect.weakness": "Braoued gwander",
  "item.minecraft.potion.effect.weaving": "Braoued gwiadiñ",
  "item.minecraft.potion.effect.wind_charged": "Braoued c'hwezh",
  "item.minecraft.pottery_shard_archer": "Darbod ar gwareger",
  "item.minecraft.pottery_shard_arms_up": "Darbod an den",
  "item.minecraft.pottery_shard_prize": "Darbod ar brageriz",
  "item.minecraft.pottery_shard_skull": "Darbod ar c'hlopenn",
  "item.minecraft.powder_snow_bucket": "Sailhad erc'h poultrek",
  "item.minecraft.prismarine_crystals": "Strink prismarine",
  "item.minecraft.prismarine_shard": "Darbod prismarine",
  "item.minecraft.prize_pottery_shard": "Darbod ar brageriz",
  "item.minecraft.prize_pottery_sherd": "Darbod ar brageriz",
  "item.minecraft.pufferfish": "Pesk-boul",
  "item.minecraft.pufferfish_bucket": "Sailhad pesk-boul",
  "item.minecraft.pufferfish_spawn_egg": "Vi genel pesk-boul",
  "item.minecraft.pumpkin_pie": "Tartezenn sitrouilhez",
  "item.minecraft.pumpkin_seeds": "Greun sitrouilhez",
  "item.minecraft.purple_bundle": "Sac'h mouk",
  "item.minecraft.purple_dye": "Livadenn vouk",
  "item.minecraft.purple_harness": "Sternaj mouk",
  "item.minecraft.quartz": "Kouarz an Nether",
  "item.minecraft.rabbit": "Kig-konikl kriz",
  "item.minecraft.rabbit_foot": "Pav konikl",
  "item.minecraft.rabbit_hide": "Kroc'hen konikl",
  "item.minecraft.rabbit_spawn_egg": "Vi genel konikl",
  "item.minecraft.rabbit_stew": "Ragoud konikl",
  "item.minecraft.raiser_armor_trim_smithing_template": "Patrom goveliañ",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Kinkladur an desaver",
  "item.minecraft.ravager_spawn_egg": "Vi genel draster",
  "item.minecraft.raw_copper": "Kouevr kriz",
  "item.minecraft.raw_gold": "Aour kriz",
  "item.minecraft.raw_iron": "Houarn kriz",
  "item.minecraft.recovery_compass": "Nadoz-vor adc'hounit",
  "item.minecraft.red_bundle": "Sac'h ruz",
  "item.minecraft.red_dye": "Livadenn ruz",
  "item.minecraft.red_harness": "Sternaj ruz",
  "item.minecraft.redstone": "Poultr Redstone",
  "item.minecraft.resin_brick": "Brikenn rousin",
  "item.minecraft.resin_clump": "Bern rousin",
  "item.minecraft.rib_armor_trim_smithing_template": "Patrom goveliañ",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Kinkladur ar gostenn",
  "item.minecraft.rotten_flesh": "Kig brein",
  "item.minecraft.saddle": "Dibr",
  "item.minecraft.salmon": "Eog kriz",
  "item.minecraft.salmon_bucket": "Sailhad eog",
  "item.minecraft.salmon_spawn_egg": "Vi genel eog",
  "item.minecraft.scrape_pottery_sherd": "Darbod ar vouc'hal",
  "item.minecraft.scute": "Skantenn",
  "item.minecraft.sentry_armor_trim_smithing_template": "Patrom goveliañ",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Kinkladur ar santinell",
  "item.minecraft.shaper_armor_trim_smithing_template": "Patrom goveliañ",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Kinkladur ar stummer",
  "item.minecraft.sheaf_pottery_shard": "Darbod an ed",
  "item.minecraft.sheaf_pottery_sherd": "Darbod an ed",
  "item.minecraft.shears": "Gweltre",
  "item.minecraft.sheep_spawn_egg": "Vi genel dañvad",
  "item.minecraft.shelter_pottery_shard": "Darbod ar gwasked",
  "item.minecraft.shelter_pottery_sherd": "Darbod ar gwasked",
  "item.minecraft.shield": "Skoed",
  "item.minecraft.shield.black": "Skoed du",
  "item.minecraft.shield.blue": "Skoed glas",
  "item.minecraft.shield.brown": "Skoed gell",
  "item.minecraft.shield.cyan": "Skoed sian",
  "item.minecraft.shield.gray": "Skoed gris",
  "item.minecraft.shield.green": "Skoed gwer",
  "item.minecraft.shield.light_blue": "Skoed glas sklaer",
  "item.minecraft.shield.light_gray": "Skoed gris sklaer",
  "item.minecraft.shield.lime": "Skoed gwer sklaer",
  "item.minecraft.shield.magenta": "Skoed limestra",
  "item.minecraft.shield.orange": "Skoed orañjez",
  "item.minecraft.shield.pink": "Skoed roz",
  "item.minecraft.shield.purple": "Skoed mouk",
  "item.minecraft.shield.red": "Skoed ruz",
  "item.minecraft.shield.white": "Skoed gwenn",
  "item.minecraft.shield.yellow": "Skoed melen",
  "item.minecraft.shulker_shell": "Krogenn Shulker",
  "item.minecraft.shulker_spawn_egg": "Vi genel Shulker",
  "item.minecraft.sign": "Panell",
  "item.minecraft.silence_armor_trim_smithing_template": "Patrom goveliañ",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Kinkladur an didrouz",
  "item.minecraft.silverfish_spawn_egg": "Vi genel pesk-arc'hant",
  "item.minecraft.skeleton_horse_spawn_egg": "Vi genel marc'h skeledenn",
  "item.minecraft.skeleton_spawn_egg": "Vi genel skeledenn",
  "item.minecraft.skull_banner_pattern": "Patrom banniel",
  "item.minecraft.skull_banner_pattern.desc": "Klopenn",
  "item.minecraft.skull_banner_pattern.new": "Patrom banniel ar c'hlopenn",
  "item.minecraft.skull_pottery_shard": "Darbod ar c'hlopenn",
  "item.minecraft.skull_pottery_sherd": "Darbod ar c'hlopenn",
  "item.minecraft.slime_ball": "Bolotenn slime",
  "item.minecraft.slime_spawn_egg": "Vi genel slime",
  "item.minecraft.smithing_template": "Patrom goveliañ",
  "item.minecraft.smithing_template.applies_to": "A vez lakaet war:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Ouzhpennit ur varrenn pe ur strinkenn",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Houarnwisk",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Ouzhpennit ur pezh harnez",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Tolzennoù ha strink",
  "item.minecraft.smithing_template.ingredients": "Danvezioù:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Ouzhpennit ur varrenn Netherite",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Dafar diamantek",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Lakait un arm, un ostilh pe harnez diamant",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Barrenn Netherite",
  "item.minecraft.smithing_template.upgrade": "Gwellaenn: ",
  "item.minecraft.sniffer_spawn_egg": "Vi genel rufler",
  "item.minecraft.snort_pottery_shard": "Darbod ar rufler",
  "item.minecraft.snort_pottery_sherd": "Darbod ar rufler",
  "item.minecraft.snout_armor_trim_smithing_template": "Patrom goveliañ",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Kinkladur ar vojell",
  "item.minecraft.snow_golem_spawn_egg": "Vi genel golem-erc'h",
  "item.minecraft.snowball": "Boulenn erc'h",
  "item.minecraft.spectral_arrow": "Bir tasmantek",
  "item.minecraft.spider_eye": "Lagad kevnidenn",
  "item.minecraft.spider_spawn_egg": "Vi genel kevnidenn",
  "item.minecraft.spire_armor_trim_smithing_template": "Patrom goveliañ",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Kinkladur an tour",
  "item.minecraft.splash_potion": "Braoued da deurel",
  "item.minecraft.splash_potion.effect.awkward": "Braoued direnkus da deurel",
  "item.minecraft.splash_potion.effect.empty": "N'haller ket aozañ ar braoued-mañ da deurel",
  "item.minecraft.splash_potion.effect.fire_resistance": "Braoued tan-gwarez da deurel",
  "item.minecraft.splash_potion.effect.harming": "Braoued freuzañ da deurel",
  "item.minecraft.splash_potion.effect.healing": "Braoued pareañ da deurel",
  "item.minecraft.splash_potion.effect.infested": "Braoued kontroniñ da deurel",
  "item.minecraft.splash_potion.effect.invisibility": "Braoued diwelusted da deurel",
  "item.minecraft.splash_potion.effect.leaping": "Braoued lammat da deurel",
  "item.minecraft.splash_potion.effect.levitation": "Braoued nijal da deurel",
  "item.minecraft.splash_potion.effect.luck": "Braoued chañs da deurel",
  "item.minecraft.splash_potion.effect.mundane": "Braoued ordinal da deurel",
  "item.minecraft.splash_potion.effect.night_vision": "Braoued gwelet en noz da deurel",
  "item.minecraft.splash_potion.effect.oozing": "Braoued gludañ da deurel",
  "item.minecraft.splash_potion.effect.poison": "Braoued ampoezon da deurel",
  "item.minecraft.splash_potion.effect.regeneration": "Braoued empraeañ da deurel",
  "item.minecraft.splash_potion.effect.slow_falling": "Braoued kouezhañ gorrek da deurel",
  "item.minecraft.splash_potion.effect.slowness": "Braoued gorrekaat da deurel",
  "item.minecraft.splash_potion.effect.strength": "Braoued kreñvder da deurel",
  "item.minecraft.splash_potion.effect.swiftness": "Braoued primder da deurel",
  "item.minecraft.splash_potion.effect.thick": "Braoued tev da deurel",
  "item.minecraft.splash_potion.effect.turtle_master": "Braoued mestr ar baoted da deurel",
  "item.minecraft.splash_potion.effect.water": "Boutailhad dour da deurel",
  "item.minecraft.splash_potion.effect.water_breathing": "Braoued analañ en dour da deurel",
  "item.minecraft.splash_potion.effect.weakness": "Braoued gwander da deurel",
  "item.minecraft.splash_potion.effect.weaving": "Braoued gwiadiñ da deurel",
  "item.minecraft.splash_potion.effect.wind_charged": "Braoued c'hwezh da deurel",
  "item.minecraft.spruce_boat": "Bag pruñs",
  "item.minecraft.spruce_chest_boat": "Bag sapr gant ur c'houfr",
  "item.minecraft.spyglass": "Lunedenn hirwel",
  "item.minecraft.squid_spawn_egg": "Vi genel stiogan",
  "item.minecraft.stick": "Bazh",
  "item.minecraft.stone_axe": "Bouc'hal vaen",
  "item.minecraft.stone_hoe": "Marr vaen",
  "item.minecraft.stone_pickaxe": "Pigell vaen",
  "item.minecraft.stone_shovel": "Pal vaen",
  "item.minecraft.stone_spear": "Goaf maen",
  "item.minecraft.stone_sword": "Kleze maen",
  "item.minecraft.stray_spawn_egg": "Vi genel kantreer",
  "item.minecraft.strider_spawn_egg": "Vi genel gaoliataer",
  "item.minecraft.string": "Neudenn",
  "item.minecraft.sugar": "Sukr",
  "item.minecraft.suspicious_stew": "Ragoud touellus",
  "item.minecraft.sweet_berries": "Skav sukret",
  "item.minecraft.tadpole_bucket": "Sailhad penndolog",
  "item.minecraft.tadpole_spawn_egg": "Vi genel penndolog",
  "item.minecraft.tide_armor_trim_smithing_template": "Patrom goveliañ",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Kinkladur al lanv",
  "item.minecraft.tipped_arrow": "Bir gant efedoù",
  "item.minecraft.tipped_arrow.effect.awkward": "Bir direnkus",
  "item.minecraft.tipped_arrow.effect.empty": "N'haller ket aozañ ar bir-mañ gant efedoù",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Bir tan-gwarez",
  "item.minecraft.tipped_arrow.effect.harming": "Bir freuzañ",
  "item.minecraft.tipped_arrow.effect.healing": "Bir pareañ",
  "item.minecraft.tipped_arrow.effect.infested": "Bir kontroniñ",
  "item.minecraft.tipped_arrow.effect.invisibility": "Bir diwelusted",
  "item.minecraft.tipped_arrow.effect.leaping": "Bir lammat",
  "item.minecraft.tipped_arrow.effect.levitation": "Bir nijal",
  "item.minecraft.tipped_arrow.effect.luck": "Bir chañs",
  "item.minecraft.tipped_arrow.effect.mundane": "Bir ordinal",
  "item.minecraft.tipped_arrow.effect.night_vision": "Bir gwelet en noz",
  "item.minecraft.tipped_arrow.effect.oozing": "Bir gludañ",
  "item.minecraft.tipped_arrow.effect.poison": "Bir ampoezonet",
  "item.minecraft.tipped_arrow.effect.regeneration": "Bir empareañ",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Bir kouezhañ gorrek",
  "item.minecraft.tipped_arrow.effect.slowness": "Bir gorregezh",
  "item.minecraft.tipped_arrow.effect.strength": "Bir kreñvder",
  "item.minecraft.tipped_arrow.effect.swiftness": "Bir primder",
  "item.minecraft.tipped_arrow.effect.thick": "Bir tev",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Bir mestr ar baoted",
  "item.minecraft.tipped_arrow.effect.water": "Bir strinkañ",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Bir analañ en dour",
  "item.minecraft.tipped_arrow.effect.weakness": "Bir gwander",
  "item.minecraft.tipped_arrow.effect.weaving": "Bir gwiadiñ",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Bir c'hwezh",
  "item.minecraft.tnt_minecart": "Bagon vengleuz gant TNT",
  "item.minecraft.torchflower_seeds": "Greun bleuñv-flamm",
  "item.minecraft.totem_of_undying": "Totem an Divarvelezh",
  "item.minecraft.trader_llama_spawn_egg": "Vi genel lama marc'hadour",
  "item.minecraft.trial_key": "Alc'hwez an daeoù",
  "item.minecraft.trident": "Tridant",
  "item.minecraft.tropical_fish": "Pesk trovanel",
  "item.minecraft.tropical_fish_bucket": "Sailhad pesk trovanel",
  "item.minecraft.tropical_fish_spawn_egg": "Vi genel pesk trovanel",
  "item.minecraft.turtle_helmet": "Krogenn vaot",
  "item.minecraft.turtle_scute": "Skantenn vaot",
  "item.minecraft.turtle_spawn_egg": "Vi genel baot",
  "item.minecraft.vex_armor_trim_smithing_template": "Patrom goveliañ",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Kinkladur ar Vex",
  "item.minecraft.vex_spawn_egg": "Vi genel vex",
  "item.minecraft.villager_spawn_egg": "Vi genel kêriadenner",
  "item.minecraft.vindicator_spawn_egg": "Vi genel gourvenner",
  "item.minecraft.wandering_trader_spawn_egg": "Vi genel marc'hadour kantreer",
  "item.minecraft.ward_armor_trim_smithing_template": "Patrom goveliañ",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Kinkladur ar gward",
  "item.minecraft.warden_spawn_egg": "Vi genel Warden",
  "item.minecraft.warped_fungus_on_a_stick": "Kabell-touseg disleber ouzh ur vazh",
  "item.minecraft.water_bucket": "Sailhad dour",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Patrom goveliañ",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Kinkladur ar sklêrijenner",
  "item.minecraft.wheat": "Ed",
  "item.minecraft.wheat_seeds": "Greun ed",
  "item.minecraft.white_bundle": "Sac'h gwenn",
  "item.minecraft.white_dye": "Livadenn wenn",
  "item.minecraft.white_harness": "Sternaj gwenn",
  "item.minecraft.wild_armor_trim_smithing_template": "Patrom goveliañ",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Kinkladur gouez",
  "item.minecraft.wind_charge": "Karg avel",
  "item.minecraft.witch_spawn_egg": "Vi genel sorserez",
  "item.minecraft.wither_skeleton_spawn_egg": "Vi genel skeledenn Wither",
  "item.minecraft.wither_spawn_egg": "Vi genel Wither",
  "item.minecraft.wolf_armor": "Harnez bleiz",
  "item.minecraft.wolf_spawn_egg": "Vi genel bleiz",
  "item.minecraft.wooden_axe": "Bouc'hal goad",
  "item.minecraft.wooden_hoe": "Marr goad",
  "item.minecraft.wooden_pickaxe": "Pigell goad",
  "item.minecraft.wooden_shovel": "Pal goad",
  "item.minecraft.wooden_spear": "Goaf koad",
  "item.minecraft.wooden_sword": "Kleze koad",
  "item.minecraft.writable_book": "Levr ha pluenn",
  "item.minecraft.written_book": "Levr skrivet",
  "item.minecraft.yellow_bundle": "Sac'h melen",
  "item.minecraft.yellow_dye": "Livadenn velen",
  "item.minecraft.yellow_harness": "Sternaj melen",
  "item.minecraft.zoglin_spawn_egg": "Vi genel Zoglin",
  "item.minecraft.zombie_horse_spawn_egg": "Vi genel marc'h zombi",
  "item.minecraft.zombie_nautilus_spawn_egg": "Vi genel naotiled zombi",
  "item.minecraft.zombie_spawn_egg": "Vi genel zombi",
  "item.minecraft.zombie_villager_spawn_egg": "Vi genel kêriadennad zombi",
  "item.minecraft.zombified_piglin_spawn_egg": "Vi genel Piglin zombifiet"
}
export const br_fr = items; 
